var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i5 = decorators.length - 1, decorator; i5 >= 0; i5--)
    if (decorator = decorators[i5])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};

// css-inline:components/ds-book-parade/ds-book-parade.css
var ds_book_parade_default = ":host {\n  display: block;\n  width: 100%;\n  height: var(--_natural-height, 400px);\n  overflow: hidden;\n  position: relative;\n  background: var(--_bg, transparent);\n}\n\ncanvas {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  transition: opacity 0.4s ease;\n}\n\n:host([ready]) canvas {\n  opacity: 1;\n}\n\nslot {\n  display: none;\n}\n\n::slotted(img) {\n  width: var(--_book-width, 76px);\n  height: var(--_book-height, 106px);\n  object-fit: cover;\n  border-radius: var(--_radius, 6px);\n}\n";

// node_modules/@lit/reactive-element/css-tag.js
var t = globalThis;
var e = t.ShadowRoot && (void 0 === t.ShadyCSS || t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype;
var s = /* @__PURE__ */ Symbol();
var o = /* @__PURE__ */ new WeakMap();
var n = class {
  constructor(t4, e5, o6) {
    if (this._$cssResult$ = true, o6 !== s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t4, this.t = e5;
  }
  get styleSheet() {
    let t4 = this.o;
    const s4 = this.t;
    if (e && void 0 === t4) {
      const e5 = void 0 !== s4 && 1 === s4.length;
      e5 && (t4 = o.get(s4)), void 0 === t4 && ((this.o = t4 = new CSSStyleSheet()).replaceSync(this.cssText), e5 && o.set(s4, t4));
    }
    return t4;
  }
  toString() {
    return this.cssText;
  }
};
var r = (t4) => new n("string" == typeof t4 ? t4 : t4 + "", void 0, s);
var i = (t4, ...e5) => {
  const o6 = 1 === t4.length ? t4[0] : e5.reduce((e6, s4, o7) => e6 + ((t5) => {
    if (true === t5._$cssResult$) return t5.cssText;
    if ("number" == typeof t5) return t5;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + t5 + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(s4) + t4[o7 + 1], t4[0]);
  return new n(o6, t4, s);
};
var S = (s4, o6) => {
  if (e) s4.adoptedStyleSheets = o6.map((t4) => t4 instanceof CSSStyleSheet ? t4 : t4.styleSheet);
  else for (const e5 of o6) {
    const o7 = document.createElement("style"), n5 = t.litNonce;
    void 0 !== n5 && o7.setAttribute("nonce", n5), o7.textContent = e5.cssText, s4.appendChild(o7);
  }
};
var c = e ? (t4) => t4 : (t4) => t4 instanceof CSSStyleSheet ? ((t5) => {
  let e5 = "";
  for (const s4 of t5.cssRules) e5 += s4.cssText;
  return r(e5);
})(t4) : t4;

// node_modules/@lit/reactive-element/reactive-element.js
var { is: i2, defineProperty: e2, getOwnPropertyDescriptor: h, getOwnPropertyNames: r2, getOwnPropertySymbols: o2, getPrototypeOf: n2 } = Object;
var a = globalThis;
var c2 = a.trustedTypes;
var l = c2 ? c2.emptyScript : "";
var p = a.reactiveElementPolyfillSupport;
var d = (t4, s4) => t4;
var u = { toAttribute(t4, s4) {
  switch (s4) {
    case Boolean:
      t4 = t4 ? l : null;
      break;
    case Object:
    case Array:
      t4 = null == t4 ? t4 : JSON.stringify(t4);
  }
  return t4;
}, fromAttribute(t4, s4) {
  let i5 = t4;
  switch (s4) {
    case Boolean:
      i5 = null !== t4;
      break;
    case Number:
      i5 = null === t4 ? null : Number(t4);
      break;
    case Object:
    case Array:
      try {
        i5 = JSON.parse(t4);
      } catch (t5) {
        i5 = null;
      }
  }
  return i5;
} };
var f = (t4, s4) => !i2(t4, s4);
var b = { attribute: true, type: String, converter: u, reflect: false, useDefault: false, hasChanged: f };
Symbol.metadata ??= /* @__PURE__ */ Symbol("metadata"), a.litPropertyMetadata ??= /* @__PURE__ */ new WeakMap();
var y = class extends HTMLElement {
  static addInitializer(t4) {
    this._$Ei(), (this.l ??= []).push(t4);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t4, s4 = b) {
    if (s4.state && (s4.attribute = false), this._$Ei(), this.prototype.hasOwnProperty(t4) && ((s4 = Object.create(s4)).wrapped = true), this.elementProperties.set(t4, s4), !s4.noAccessor) {
      const i5 = /* @__PURE__ */ Symbol(), h3 = this.getPropertyDescriptor(t4, i5, s4);
      void 0 !== h3 && e2(this.prototype, t4, h3);
    }
  }
  static getPropertyDescriptor(t4, s4, i5) {
    const { get: e5, set: r5 } = h(this.prototype, t4) ?? { get() {
      return this[s4];
    }, set(t5) {
      this[s4] = t5;
    } };
    return { get: e5, set(s5) {
      const h3 = e5?.call(this);
      r5?.call(this, s5), this.requestUpdate(t4, h3, i5);
    }, configurable: true, enumerable: true };
  }
  static getPropertyOptions(t4) {
    return this.elementProperties.get(t4) ?? b;
  }
  static _$Ei() {
    if (this.hasOwnProperty(d("elementProperties"))) return;
    const t4 = n2(this);
    t4.finalize(), void 0 !== t4.l && (this.l = [...t4.l]), this.elementProperties = new Map(t4.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(d("finalized"))) return;
    if (this.finalized = true, this._$Ei(), this.hasOwnProperty(d("properties"))) {
      const t5 = this.properties, s4 = [...r2(t5), ...o2(t5)];
      for (const i5 of s4) this.createProperty(i5, t5[i5]);
    }
    const t4 = this[Symbol.metadata];
    if (null !== t4) {
      const s4 = litPropertyMetadata.get(t4);
      if (void 0 !== s4) for (const [t5, i5] of s4) this.elementProperties.set(t5, i5);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [t5, s4] of this.elementProperties) {
      const i5 = this._$Eu(t5, s4);
      void 0 !== i5 && this._$Eh.set(i5, t5);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(s4) {
    const i5 = [];
    if (Array.isArray(s4)) {
      const e5 = new Set(s4.flat(1 / 0).reverse());
      for (const s5 of e5) i5.unshift(c(s5));
    } else void 0 !== s4 && i5.push(c(s4));
    return i5;
  }
  static _$Eu(t4, s4) {
    const i5 = s4.attribute;
    return false === i5 ? void 0 : "string" == typeof i5 ? i5 : "string" == typeof t4 ? t4.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = false, this.hasUpdated = false, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    this._$ES = new Promise((t4) => this.enableUpdating = t4), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t4) => t4(this));
  }
  addController(t4) {
    (this._$EO ??= /* @__PURE__ */ new Set()).add(t4), void 0 !== this.renderRoot && this.isConnected && t4.hostConnected?.();
  }
  removeController(t4) {
    this._$EO?.delete(t4);
  }
  _$E_() {
    const t4 = /* @__PURE__ */ new Map(), s4 = this.constructor.elementProperties;
    for (const i5 of s4.keys()) this.hasOwnProperty(i5) && (t4.set(i5, this[i5]), delete this[i5]);
    t4.size > 0 && (this._$Ep = t4);
  }
  createRenderRoot() {
    const t4 = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return S(t4, this.constructor.elementStyles), t4;
  }
  connectedCallback() {
    this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(true), this._$EO?.forEach((t4) => t4.hostConnected?.());
  }
  enableUpdating(t4) {
  }
  disconnectedCallback() {
    this._$EO?.forEach((t4) => t4.hostDisconnected?.());
  }
  attributeChangedCallback(t4, s4, i5) {
    this._$AK(t4, i5);
  }
  _$ET(t4, s4) {
    const i5 = this.constructor.elementProperties.get(t4), e5 = this.constructor._$Eu(t4, i5);
    if (void 0 !== e5 && true === i5.reflect) {
      const h3 = (void 0 !== i5.converter?.toAttribute ? i5.converter : u).toAttribute(s4, i5.type);
      this._$Em = t4, null == h3 ? this.removeAttribute(e5) : this.setAttribute(e5, h3), this._$Em = null;
    }
  }
  _$AK(t4, s4) {
    const i5 = this.constructor, e5 = i5._$Eh.get(t4);
    if (void 0 !== e5 && this._$Em !== e5) {
      const t5 = i5.getPropertyOptions(e5), h3 = "function" == typeof t5.converter ? { fromAttribute: t5.converter } : void 0 !== t5.converter?.fromAttribute ? t5.converter : u;
      this._$Em = e5;
      const r5 = h3.fromAttribute(s4, t5.type);
      this[e5] = r5 ?? this._$Ej?.get(e5) ?? r5, this._$Em = null;
    }
  }
  requestUpdate(t4, s4, i5, e5 = false, h3) {
    if (void 0 !== t4) {
      const r5 = this.constructor;
      if (false === e5 && (h3 = this[t4]), i5 ??= r5.getPropertyOptions(t4), !((i5.hasChanged ?? f)(h3, s4) || i5.useDefault && i5.reflect && h3 === this._$Ej?.get(t4) && !this.hasAttribute(r5._$Eu(t4, i5)))) return;
      this.C(t4, s4, i5);
    }
    false === this.isUpdatePending && (this._$ES = this._$EP());
  }
  C(t4, s4, { useDefault: i5, reflect: e5, wrapped: h3 }, r5) {
    i5 && !(this._$Ej ??= /* @__PURE__ */ new Map()).has(t4) && (this._$Ej.set(t4, r5 ?? s4 ?? this[t4]), true !== h3 || void 0 !== r5) || (this._$AL.has(t4) || (this.hasUpdated || i5 || (s4 = void 0), this._$AL.set(t4, s4)), true === e5 && this._$Em !== t4 && (this._$Eq ??= /* @__PURE__ */ new Set()).add(t4));
  }
  async _$EP() {
    this.isUpdatePending = true;
    try {
      await this._$ES;
    } catch (t5) {
      Promise.reject(t5);
    }
    const t4 = this.scheduleUpdate();
    return null != t4 && await t4, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
        for (const [t6, s5] of this._$Ep) this[t6] = s5;
        this._$Ep = void 0;
      }
      const t5 = this.constructor.elementProperties;
      if (t5.size > 0) for (const [s5, i5] of t5) {
        const { wrapped: t6 } = i5, e5 = this[s5];
        true !== t6 || this._$AL.has(s5) || void 0 === e5 || this.C(s5, void 0, i5, e5);
      }
    }
    let t4 = false;
    const s4 = this._$AL;
    try {
      t4 = this.shouldUpdate(s4), t4 ? (this.willUpdate(s4), this._$EO?.forEach((t5) => t5.hostUpdate?.()), this.update(s4)) : this._$EM();
    } catch (s5) {
      throw t4 = false, this._$EM(), s5;
    }
    t4 && this._$AE(s4);
  }
  willUpdate(t4) {
  }
  _$AE(t4) {
    this._$EO?.forEach((t5) => t5.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = true, this.firstUpdated(t4)), this.updated(t4);
  }
  _$EM() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = false;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t4) {
    return true;
  }
  update(t4) {
    this._$Eq &&= this._$Eq.forEach((t5) => this._$ET(t5, this[t5])), this._$EM();
  }
  updated(t4) {
  }
  firstUpdated(t4) {
  }
};
y.elementStyles = [], y.shadowRootOptions = { mode: "open" }, y[d("elementProperties")] = /* @__PURE__ */ new Map(), y[d("finalized")] = /* @__PURE__ */ new Map(), p?.({ ReactiveElement: y }), (a.reactiveElementVersions ??= []).push("2.1.2");

// node_modules/lit-html/lit-html.js
var t2 = globalThis;
var i3 = (t4) => t4;
var s2 = t2.trustedTypes;
var e3 = s2 ? s2.createPolicy("lit-html", { createHTML: (t4) => t4 }) : void 0;
var h2 = "$lit$";
var o3 = `lit$${Math.random().toFixed(9).slice(2)}$`;
var n3 = "?" + o3;
var r3 = `<${n3}>`;
var l2 = document;
var c3 = () => l2.createComment("");
var a2 = (t4) => null === t4 || "object" != typeof t4 && "function" != typeof t4;
var u2 = Array.isArray;
var d2 = (t4) => u2(t4) || "function" == typeof t4?.[Symbol.iterator];
var f2 = "[ 	\n\f\r]";
var v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g;
var _ = /-->/g;
var m = />/g;
var p2 = RegExp(`>|${f2}(?:([^\\s"'>=/]+)(${f2}*=${f2}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g");
var g = /'/g;
var $ = /"/g;
var y2 = /^(?:script|style|textarea|title)$/i;
var x = (t4) => (i5, ...s4) => ({ _$litType$: t4, strings: i5, values: s4 });
var b2 = x(1);
var w = x(2);
var T = x(3);
var E = /* @__PURE__ */ Symbol.for("lit-noChange");
var A = /* @__PURE__ */ Symbol.for("lit-nothing");
var C = /* @__PURE__ */ new WeakMap();
var P = l2.createTreeWalker(l2, 129);
function V(t4, i5) {
  if (!u2(t4) || !t4.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return void 0 !== e3 ? e3.createHTML(i5) : i5;
}
var N = (t4, i5) => {
  const s4 = t4.length - 1, e5 = [];
  let n5, l3 = 2 === i5 ? "<svg>" : 3 === i5 ? "<math>" : "", c4 = v;
  for (let i6 = 0; i6 < s4; i6++) {
    const s5 = t4[i6];
    let a3, u3, d3 = -1, f3 = 0;
    for (; f3 < s5.length && (c4.lastIndex = f3, u3 = c4.exec(s5), null !== u3); ) f3 = c4.lastIndex, c4 === v ? "!--" === u3[1] ? c4 = _ : void 0 !== u3[1] ? c4 = m : void 0 !== u3[2] ? (y2.test(u3[2]) && (n5 = RegExp("</" + u3[2], "g")), c4 = p2) : void 0 !== u3[3] && (c4 = p2) : c4 === p2 ? ">" === u3[0] ? (c4 = n5 ?? v, d3 = -1) : void 0 === u3[1] ? d3 = -2 : (d3 = c4.lastIndex - u3[2].length, a3 = u3[1], c4 = void 0 === u3[3] ? p2 : '"' === u3[3] ? $ : g) : c4 === $ || c4 === g ? c4 = p2 : c4 === _ || c4 === m ? c4 = v : (c4 = p2, n5 = void 0);
    const x2 = c4 === p2 && t4[i6 + 1].startsWith("/>") ? " " : "";
    l3 += c4 === v ? s5 + r3 : d3 >= 0 ? (e5.push(a3), s5.slice(0, d3) + h2 + s5.slice(d3) + o3 + x2) : s5 + o3 + (-2 === d3 ? i6 : x2);
  }
  return [V(t4, l3 + (t4[s4] || "<?>") + (2 === i5 ? "</svg>" : 3 === i5 ? "</math>" : "")), e5];
};
var S2 = class _S {
  constructor({ strings: t4, _$litType$: i5 }, e5) {
    let r5;
    this.parts = [];
    let l3 = 0, a3 = 0;
    const u3 = t4.length - 1, d3 = this.parts, [f3, v2] = N(t4, i5);
    if (this.el = _S.createElement(f3, e5), P.currentNode = this.el.content, 2 === i5 || 3 === i5) {
      const t5 = this.el.content.firstChild;
      t5.replaceWith(...t5.childNodes);
    }
    for (; null !== (r5 = P.nextNode()) && d3.length < u3; ) {
      if (1 === r5.nodeType) {
        if (r5.hasAttributes()) for (const t5 of r5.getAttributeNames()) if (t5.endsWith(h2)) {
          const i6 = v2[a3++], s4 = r5.getAttribute(t5).split(o3), e6 = /([.?@])?(.*)/.exec(i6);
          d3.push({ type: 1, index: l3, name: e6[2], strings: s4, ctor: "." === e6[1] ? I : "?" === e6[1] ? L : "@" === e6[1] ? z : H }), r5.removeAttribute(t5);
        } else t5.startsWith(o3) && (d3.push({ type: 6, index: l3 }), r5.removeAttribute(t5));
        if (y2.test(r5.tagName)) {
          const t5 = r5.textContent.split(o3), i6 = t5.length - 1;
          if (i6 > 0) {
            r5.textContent = s2 ? s2.emptyScript : "";
            for (let s4 = 0; s4 < i6; s4++) r5.append(t5[s4], c3()), P.nextNode(), d3.push({ type: 2, index: ++l3 });
            r5.append(t5[i6], c3());
          }
        }
      } else if (8 === r5.nodeType) if (r5.data === n3) d3.push({ type: 2, index: l3 });
      else {
        let t5 = -1;
        for (; -1 !== (t5 = r5.data.indexOf(o3, t5 + 1)); ) d3.push({ type: 7, index: l3 }), t5 += o3.length - 1;
      }
      l3++;
    }
  }
  static createElement(t4, i5) {
    const s4 = l2.createElement("template");
    return s4.innerHTML = t4, s4;
  }
};
function M(t4, i5, s4 = t4, e5) {
  if (i5 === E) return i5;
  let h3 = void 0 !== e5 ? s4._$Co?.[e5] : s4._$Cl;
  const o6 = a2(i5) ? void 0 : i5._$litDirective$;
  return h3?.constructor !== o6 && (h3?._$AO?.(false), void 0 === o6 ? h3 = void 0 : (h3 = new o6(t4), h3._$AT(t4, s4, e5)), void 0 !== e5 ? (s4._$Co ??= [])[e5] = h3 : s4._$Cl = h3), void 0 !== h3 && (i5 = M(t4, h3._$AS(t4, i5.values), h3, e5)), i5;
}
var R = class {
  constructor(t4, i5) {
    this._$AV = [], this._$AN = void 0, this._$AD = t4, this._$AM = i5;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t4) {
    const { el: { content: i5 }, parts: s4 } = this._$AD, e5 = (t4?.creationScope ?? l2).importNode(i5, true);
    P.currentNode = e5;
    let h3 = P.nextNode(), o6 = 0, n5 = 0, r5 = s4[0];
    for (; void 0 !== r5; ) {
      if (o6 === r5.index) {
        let i6;
        2 === r5.type ? i6 = new k(h3, h3.nextSibling, this, t4) : 1 === r5.type ? i6 = new r5.ctor(h3, r5.name, r5.strings, this, t4) : 6 === r5.type && (i6 = new Z(h3, this, t4)), this._$AV.push(i6), r5 = s4[++n5];
      }
      o6 !== r5?.index && (h3 = P.nextNode(), o6++);
    }
    return P.currentNode = l2, e5;
  }
  p(t4) {
    let i5 = 0;
    for (const s4 of this._$AV) void 0 !== s4 && (void 0 !== s4.strings ? (s4._$AI(t4, s4, i5), i5 += s4.strings.length - 2) : s4._$AI(t4[i5])), i5++;
  }
};
var k = class _k {
  get _$AU() {
    return this._$AM?._$AU ?? this._$Cv;
  }
  constructor(t4, i5, s4, e5) {
    this.type = 2, this._$AH = A, this._$AN = void 0, this._$AA = t4, this._$AB = i5, this._$AM = s4, this.options = e5, this._$Cv = e5?.isConnected ?? true;
  }
  get parentNode() {
    let t4 = this._$AA.parentNode;
    const i5 = this._$AM;
    return void 0 !== i5 && 11 === t4?.nodeType && (t4 = i5.parentNode), t4;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t4, i5 = this) {
    t4 = M(this, t4, i5), a2(t4) ? t4 === A || null == t4 || "" === t4 ? (this._$AH !== A && this._$AR(), this._$AH = A) : t4 !== this._$AH && t4 !== E && this._(t4) : void 0 !== t4._$litType$ ? this.$(t4) : void 0 !== t4.nodeType ? this.T(t4) : d2(t4) ? this.k(t4) : this._(t4);
  }
  O(t4) {
    return this._$AA.parentNode.insertBefore(t4, this._$AB);
  }
  T(t4) {
    this._$AH !== t4 && (this._$AR(), this._$AH = this.O(t4));
  }
  _(t4) {
    this._$AH !== A && a2(this._$AH) ? this._$AA.nextSibling.data = t4 : this.T(l2.createTextNode(t4)), this._$AH = t4;
  }
  $(t4) {
    const { values: i5, _$litType$: s4 } = t4, e5 = "number" == typeof s4 ? this._$AC(t4) : (void 0 === s4.el && (s4.el = S2.createElement(V(s4.h, s4.h[0]), this.options)), s4);
    if (this._$AH?._$AD === e5) this._$AH.p(i5);
    else {
      const t5 = new R(e5, this), s5 = t5.u(this.options);
      t5.p(i5), this.T(s5), this._$AH = t5;
    }
  }
  _$AC(t4) {
    let i5 = C.get(t4.strings);
    return void 0 === i5 && C.set(t4.strings, i5 = new S2(t4)), i5;
  }
  k(t4) {
    u2(this._$AH) || (this._$AH = [], this._$AR());
    const i5 = this._$AH;
    let s4, e5 = 0;
    for (const h3 of t4) e5 === i5.length ? i5.push(s4 = new _k(this.O(c3()), this.O(c3()), this, this.options)) : s4 = i5[e5], s4._$AI(h3), e5++;
    e5 < i5.length && (this._$AR(s4 && s4._$AB.nextSibling, e5), i5.length = e5);
  }
  _$AR(t4 = this._$AA.nextSibling, s4) {
    for (this._$AP?.(false, true, s4); t4 !== this._$AB; ) {
      const s5 = i3(t4).nextSibling;
      i3(t4).remove(), t4 = s5;
    }
  }
  setConnected(t4) {
    void 0 === this._$AM && (this._$Cv = t4, this._$AP?.(t4));
  }
};
var H = class {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t4, i5, s4, e5, h3) {
    this.type = 1, this._$AH = A, this._$AN = void 0, this.element = t4, this.name = i5, this._$AM = e5, this.options = h3, s4.length > 2 || "" !== s4[0] || "" !== s4[1] ? (this._$AH = Array(s4.length - 1).fill(new String()), this.strings = s4) : this._$AH = A;
  }
  _$AI(t4, i5 = this, s4, e5) {
    const h3 = this.strings;
    let o6 = false;
    if (void 0 === h3) t4 = M(this, t4, i5, 0), o6 = !a2(t4) || t4 !== this._$AH && t4 !== E, o6 && (this._$AH = t4);
    else {
      const e6 = t4;
      let n5, r5;
      for (t4 = h3[0], n5 = 0; n5 < h3.length - 1; n5++) r5 = M(this, e6[s4 + n5], i5, n5), r5 === E && (r5 = this._$AH[n5]), o6 ||= !a2(r5) || r5 !== this._$AH[n5], r5 === A ? t4 = A : t4 !== A && (t4 += (r5 ?? "") + h3[n5 + 1]), this._$AH[n5] = r5;
    }
    o6 && !e5 && this.j(t4);
  }
  j(t4) {
    t4 === A ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t4 ?? "");
  }
};
var I = class extends H {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t4) {
    this.element[this.name] = t4 === A ? void 0 : t4;
  }
};
var L = class extends H {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t4) {
    this.element.toggleAttribute(this.name, !!t4 && t4 !== A);
  }
};
var z = class extends H {
  constructor(t4, i5, s4, e5, h3) {
    super(t4, i5, s4, e5, h3), this.type = 5;
  }
  _$AI(t4, i5 = this) {
    if ((t4 = M(this, t4, i5, 0) ?? A) === E) return;
    const s4 = this._$AH, e5 = t4 === A && s4 !== A || t4.capture !== s4.capture || t4.once !== s4.once || t4.passive !== s4.passive, h3 = t4 !== A && (s4 === A || e5);
    e5 && this.element.removeEventListener(this.name, this, s4), h3 && this.element.addEventListener(this.name, this, t4), this._$AH = t4;
  }
  handleEvent(t4) {
    "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t4) : this._$AH.handleEvent(t4);
  }
};
var Z = class {
  constructor(t4, i5, s4) {
    this.element = t4, this.type = 6, this._$AN = void 0, this._$AM = i5, this.options = s4;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t4) {
    M(this, t4);
  }
};
var B = t2.litHtmlPolyfillSupport;
B?.(S2, k), (t2.litHtmlVersions ??= []).push("3.3.3");
var D = (t4, i5, s4) => {
  const e5 = s4?.renderBefore ?? i5;
  let h3 = e5._$litPart$;
  if (void 0 === h3) {
    const t5 = s4?.renderBefore ?? null;
    e5._$litPart$ = h3 = new k(i5.insertBefore(c3(), t5), t5, void 0, s4 ?? {});
  }
  return h3._$AI(t4), h3;
};

// node_modules/lit-element/lit-element.js
var s3 = globalThis;
var i4 = class extends y {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    const t4 = super.createRenderRoot();
    return this.renderOptions.renderBefore ??= t4.firstChild, t4;
  }
  update(t4) {
    const r5 = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t4), this._$Do = D(r5, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    super.connectedCallback(), this._$Do?.setConnected(true);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._$Do?.setConnected(false);
  }
  render() {
    return E;
  }
};
i4._$litElement$ = true, i4["finalized"] = true, s3.litElementHydrateSupport?.({ LitElement: i4 });
var o4 = s3.litElementPolyfillSupport;
o4?.({ LitElement: i4 });
(s3.litElementVersions ??= []).push("4.2.2");

// node_modules/@lit/reactive-element/decorators/custom-element.js
var t3 = (t4) => (e5, o6) => {
  void 0 !== o6 ? o6.addInitializer(() => {
    customElements.define(t4, e5);
  }) : customElements.define(t4, e5);
};

// node_modules/@lit/reactive-element/decorators/property.js
var o5 = { attribute: true, type: String, converter: u, reflect: false, hasChanged: f };
var r4 = (t4 = o5, e5, r5) => {
  const { kind: n5, metadata: i5 } = r5;
  let s4 = globalThis.litPropertyMetadata.get(i5);
  if (void 0 === s4 && globalThis.litPropertyMetadata.set(i5, s4 = /* @__PURE__ */ new Map()), "setter" === n5 && ((t4 = Object.create(t4)).wrapped = true), s4.set(r5.name, t4), "accessor" === n5) {
    const { name: o6 } = r5;
    return { set(r6) {
      const n6 = e5.get.call(this);
      e5.set.call(this, r6), this.requestUpdate(o6, n6, t4, true, r6);
    }, init(e6) {
      return void 0 !== e6 && this.C(o6, void 0, t4, e6), e6;
    } };
  }
  if ("setter" === n5) {
    const { name: o6 } = r5;
    return function(r6) {
      const n6 = this[o6];
      e5.call(this, r6), this.requestUpdate(o6, n6, t4, true, r6);
    };
  }
  throw Error("Unsupported decorator location: " + n5);
};
function n4(t4) {
  return (e5, o6) => "object" == typeof o6 ? r4(t4, e5, o6) : ((t5, e6, o7) => {
    const r5 = e6.hasOwnProperty(o7);
    return e6.constructor.createProperty(o7, t5), r5 ? Object.getOwnPropertyDescriptor(e6, o7) : void 0;
  })(t4, e5, o6);
}

// components/styles/shared.ts
var shared = i`
  button {
    all: unset;
    box-sizing: border-box;
    cursor: pointer;
  }

  button:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }

  .button-wrapper {
    all: unset;
    box-sizing: border-box;
    display: flex;
    cursor: pointer;
  }

  * {
    box-sizing: border-box;
    min-width: 0;
  }

  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }
`;

// components/base-component.ts
var BaseComponent = class extends i4 {
  static {
    this.styles = [shared];
  }
};

// node_modules/ogl/src/math/functions/Vec3Func.js
function length(a3) {
  let x2 = a3[0];
  let y3 = a3[1];
  let z2 = a3[2];
  return Math.sqrt(x2 * x2 + y3 * y3 + z2 * z2);
}
function copy(out, a3) {
  out[0] = a3[0];
  out[1] = a3[1];
  out[2] = a3[2];
  return out;
}
function set(out, x2, y3, z2) {
  out[0] = x2;
  out[1] = y3;
  out[2] = z2;
  return out;
}
function add(out, a3, b3) {
  out[0] = a3[0] + b3[0];
  out[1] = a3[1] + b3[1];
  out[2] = a3[2] + b3[2];
  return out;
}
function subtract(out, a3, b3) {
  out[0] = a3[0] - b3[0];
  out[1] = a3[1] - b3[1];
  out[2] = a3[2] - b3[2];
  return out;
}
function multiply(out, a3, b3) {
  out[0] = a3[0] * b3[0];
  out[1] = a3[1] * b3[1];
  out[2] = a3[2] * b3[2];
  return out;
}
function divide(out, a3, b3) {
  out[0] = a3[0] / b3[0];
  out[1] = a3[1] / b3[1];
  out[2] = a3[2] / b3[2];
  return out;
}
function scale(out, a3, b3) {
  out[0] = a3[0] * b3;
  out[1] = a3[1] * b3;
  out[2] = a3[2] * b3;
  return out;
}
function distance(a3, b3) {
  let x2 = b3[0] - a3[0];
  let y3 = b3[1] - a3[1];
  let z2 = b3[2] - a3[2];
  return Math.sqrt(x2 * x2 + y3 * y3 + z2 * z2);
}
function squaredDistance(a3, b3) {
  let x2 = b3[0] - a3[0];
  let y3 = b3[1] - a3[1];
  let z2 = b3[2] - a3[2];
  return x2 * x2 + y3 * y3 + z2 * z2;
}
function squaredLength(a3) {
  let x2 = a3[0];
  let y3 = a3[1];
  let z2 = a3[2];
  return x2 * x2 + y3 * y3 + z2 * z2;
}
function negate(out, a3) {
  out[0] = -a3[0];
  out[1] = -a3[1];
  out[2] = -a3[2];
  return out;
}
function inverse(out, a3) {
  out[0] = 1 / a3[0];
  out[1] = 1 / a3[1];
  out[2] = 1 / a3[2];
  return out;
}
function normalize(out, a3) {
  let x2 = a3[0];
  let y3 = a3[1];
  let z2 = a3[2];
  let len = x2 * x2 + y3 * y3 + z2 * z2;
  if (len > 0) {
    len = 1 / Math.sqrt(len);
  }
  out[0] = a3[0] * len;
  out[1] = a3[1] * len;
  out[2] = a3[2] * len;
  return out;
}
function dot(a3, b3) {
  return a3[0] * b3[0] + a3[1] * b3[1] + a3[2] * b3[2];
}
function cross(out, a3, b3) {
  let ax = a3[0], ay = a3[1], az = a3[2];
  let bx = b3[0], by = b3[1], bz = b3[2];
  out[0] = ay * bz - az * by;
  out[1] = az * bx - ax * bz;
  out[2] = ax * by - ay * bx;
  return out;
}
function lerp(out, a3, b3, t4) {
  let ax = a3[0];
  let ay = a3[1];
  let az = a3[2];
  out[0] = ax + t4 * (b3[0] - ax);
  out[1] = ay + t4 * (b3[1] - ay);
  out[2] = az + t4 * (b3[2] - az);
  return out;
}
function smoothLerp(out, a3, b3, decay, dt) {
  const exp = Math.exp(-decay * dt);
  let ax = a3[0];
  let ay = a3[1];
  let az = a3[2];
  out[0] = b3[0] + (ax - b3[0]) * exp;
  out[1] = b3[1] + (ay - b3[1]) * exp;
  out[2] = b3[2] + (az - b3[2]) * exp;
  return out;
}
function transformMat4(out, a3, m2) {
  let x2 = a3[0], y3 = a3[1], z2 = a3[2];
  let w2 = m2[3] * x2 + m2[7] * y3 + m2[11] * z2 + m2[15];
  w2 = w2 || 1;
  out[0] = (m2[0] * x2 + m2[4] * y3 + m2[8] * z2 + m2[12]) / w2;
  out[1] = (m2[1] * x2 + m2[5] * y3 + m2[9] * z2 + m2[13]) / w2;
  out[2] = (m2[2] * x2 + m2[6] * y3 + m2[10] * z2 + m2[14]) / w2;
  return out;
}
function scaleRotateMat4(out, a3, m2) {
  let x2 = a3[0], y3 = a3[1], z2 = a3[2];
  let w2 = m2[3] * x2 + m2[7] * y3 + m2[11] * z2 + m2[15];
  w2 = w2 || 1;
  out[0] = (m2[0] * x2 + m2[4] * y3 + m2[8] * z2) / w2;
  out[1] = (m2[1] * x2 + m2[5] * y3 + m2[9] * z2) / w2;
  out[2] = (m2[2] * x2 + m2[6] * y3 + m2[10] * z2) / w2;
  return out;
}
function transformMat3(out, a3, m2) {
  let x2 = a3[0], y3 = a3[1], z2 = a3[2];
  out[0] = x2 * m2[0] + y3 * m2[3] + z2 * m2[6];
  out[1] = x2 * m2[1] + y3 * m2[4] + z2 * m2[7];
  out[2] = x2 * m2[2] + y3 * m2[5] + z2 * m2[8];
  return out;
}
function transformQuat(out, a3, q) {
  let x2 = a3[0], y3 = a3[1], z2 = a3[2];
  let qx = q[0], qy = q[1], qz = q[2], qw = q[3];
  let uvx = qy * z2 - qz * y3;
  let uvy = qz * x2 - qx * z2;
  let uvz = qx * y3 - qy * x2;
  let uuvx = qy * uvz - qz * uvy;
  let uuvy = qz * uvx - qx * uvz;
  let uuvz = qx * uvy - qy * uvx;
  let w2 = qw * 2;
  uvx *= w2;
  uvy *= w2;
  uvz *= w2;
  uuvx *= 2;
  uuvy *= 2;
  uuvz *= 2;
  out[0] = x2 + uvx + uuvx;
  out[1] = y3 + uvy + uuvy;
  out[2] = z2 + uvz + uuvz;
  return out;
}
var angle = /* @__PURE__ */ (function() {
  const tempA = [0, 0, 0];
  const tempB = [0, 0, 0];
  return function(a3, b3) {
    copy(tempA, a3);
    copy(tempB, b3);
    normalize(tempA, tempA);
    normalize(tempB, tempB);
    let cosine = dot(tempA, tempB);
    if (cosine > 1) {
      return 0;
    } else if (cosine < -1) {
      return Math.PI;
    } else {
      return Math.acos(cosine);
    }
  };
})();
function exactEquals(a3, b3) {
  return a3[0] === b3[0] && a3[1] === b3[1] && a3[2] === b3[2];
}

// node_modules/ogl/src/math/Vec3.js
var Vec3 = class _Vec3 extends Array {
  constructor(x2 = 0, y3 = x2, z2 = x2) {
    super(x2, y3, z2);
    return this;
  }
  get x() {
    return this[0];
  }
  get y() {
    return this[1];
  }
  get z() {
    return this[2];
  }
  set x(v2) {
    this[0] = v2;
  }
  set y(v2) {
    this[1] = v2;
  }
  set z(v2) {
    this[2] = v2;
  }
  set(x2, y3 = x2, z2 = x2) {
    if (x2.length) return this.copy(x2);
    set(this, x2, y3, z2);
    return this;
  }
  copy(v2) {
    copy(this, v2);
    return this;
  }
  add(va, vb) {
    if (vb) add(this, va, vb);
    else add(this, this, va);
    return this;
  }
  sub(va, vb) {
    if (vb) subtract(this, va, vb);
    else subtract(this, this, va);
    return this;
  }
  multiply(v2) {
    if (v2.length) multiply(this, this, v2);
    else scale(this, this, v2);
    return this;
  }
  divide(v2) {
    if (v2.length) divide(this, this, v2);
    else scale(this, this, 1 / v2);
    return this;
  }
  inverse(v2 = this) {
    inverse(this, v2);
    return this;
  }
  // Can't use 'length' as Array.prototype uses it
  len() {
    return length(this);
  }
  distance(v2) {
    if (v2) return distance(this, v2);
    else return length(this);
  }
  squaredLen() {
    return squaredLength(this);
  }
  squaredDistance(v2) {
    if (v2) return squaredDistance(this, v2);
    else return squaredLength(this);
  }
  negate(v2 = this) {
    negate(this, v2);
    return this;
  }
  cross(va, vb) {
    if (vb) cross(this, va, vb);
    else cross(this, this, va);
    return this;
  }
  scale(v2) {
    scale(this, this, v2);
    return this;
  }
  normalize() {
    normalize(this, this);
    return this;
  }
  dot(v2) {
    return dot(this, v2);
  }
  equals(v2) {
    return exactEquals(this, v2);
  }
  applyMatrix3(mat3) {
    transformMat3(this, this, mat3);
    return this;
  }
  applyMatrix4(mat4) {
    transformMat4(this, this, mat4);
    return this;
  }
  scaleRotateMatrix4(mat4) {
    scaleRotateMat4(this, this, mat4);
    return this;
  }
  applyQuaternion(q) {
    transformQuat(this, this, q);
    return this;
  }
  angle(v2) {
    return angle(this, v2);
  }
  lerp(v2, t4) {
    lerp(this, this, v2, t4);
    return this;
  }
  smoothLerp(v2, decay, dt) {
    smoothLerp(this, this, v2, decay, dt);
    return this;
  }
  clone() {
    return new _Vec3(this[0], this[1], this[2]);
  }
  fromArray(a3, o6 = 0) {
    this[0] = a3[o6];
    this[1] = a3[o6 + 1];
    this[2] = a3[o6 + 2];
    return this;
  }
  toArray(a3 = [], o6 = 0) {
    a3[o6] = this[0];
    a3[o6 + 1] = this[1];
    a3[o6 + 2] = this[2];
    return a3;
  }
  transformDirection(mat4) {
    const x2 = this[0];
    const y3 = this[1];
    const z2 = this[2];
    this[0] = mat4[0] * x2 + mat4[4] * y3 + mat4[8] * z2;
    this[1] = mat4[1] * x2 + mat4[5] * y3 + mat4[9] * z2;
    this[2] = mat4[2] * x2 + mat4[6] * y3 + mat4[10] * z2;
    return this.normalize();
  }
};

// node_modules/ogl/src/core/Geometry.js
var tempVec3 = /* @__PURE__ */ new Vec3();
var ID = 1;
var ATTR_ID = 1;
var isBoundsWarned = false;
var Geometry = class {
  constructor(gl, attributes = {}) {
    if (!gl.canvas) console.error("gl not passed as first argument to Geometry");
    this.gl = gl;
    this.attributes = attributes;
    this.id = ID++;
    this.VAOs = {};
    this.drawRange = { start: 0, count: 0 };
    this.instancedCount = 0;
    this.gl.renderer.bindVertexArray(null);
    this.gl.renderer.currentGeometry = null;
    this.glState = this.gl.renderer.state;
    for (let key in attributes) {
      this.addAttribute(key, attributes[key]);
    }
  }
  addAttribute(key, attr) {
    this.attributes[key] = attr;
    attr.id = ATTR_ID++;
    attr.size = attr.size || 1;
    attr.type = attr.type || (attr.data.constructor === Float32Array ? this.gl.FLOAT : attr.data.constructor === Uint16Array ? this.gl.UNSIGNED_SHORT : this.gl.UNSIGNED_INT);
    attr.target = key === "index" ? this.gl.ELEMENT_ARRAY_BUFFER : this.gl.ARRAY_BUFFER;
    attr.normalized = attr.normalized || false;
    attr.stride = attr.stride || 0;
    attr.offset = attr.offset || 0;
    attr.count = attr.count || (attr.stride ? attr.data.byteLength / attr.stride : attr.data.length / attr.size);
    attr.divisor = attr.instanced || 0;
    attr.needsUpdate = false;
    attr.usage = attr.usage || this.gl.STATIC_DRAW;
    if (!attr.buffer) {
      this.updateAttribute(attr);
    }
    if (attr.divisor) {
      this.isInstanced = true;
      if (this.instancedCount && this.instancedCount !== attr.count * attr.divisor) {
        console.warn("geometry has multiple instanced buffers of different length");
        return this.instancedCount = Math.min(this.instancedCount, attr.count * attr.divisor);
      }
      this.instancedCount = attr.count * attr.divisor;
    } else if (key === "index") {
      this.drawRange.count = attr.count;
    } else if (!this.attributes.index) {
      this.drawRange.count = Math.max(this.drawRange.count, attr.count);
    }
  }
  updateAttribute(attr) {
    const isNewBuffer = !attr.buffer;
    if (isNewBuffer) attr.buffer = this.gl.createBuffer();
    if (this.glState.boundBuffer !== attr.buffer) {
      this.gl.bindBuffer(attr.target, attr.buffer);
      this.glState.boundBuffer = attr.buffer;
    }
    if (isNewBuffer) {
      this.gl.bufferData(attr.target, attr.data, attr.usage);
    } else {
      this.gl.bufferSubData(attr.target, 0, attr.data);
    }
    attr.needsUpdate = false;
  }
  setIndex(value) {
    this.addAttribute("index", value);
  }
  setDrawRange(start, count) {
    this.drawRange.start = start;
    this.drawRange.count = count;
  }
  setInstancedCount(value) {
    this.instancedCount = value;
  }
  createVAO(program) {
    this.VAOs[program.attributeOrder] = this.gl.renderer.createVertexArray();
    this.gl.renderer.bindVertexArray(this.VAOs[program.attributeOrder]);
    this.bindAttributes(program);
  }
  bindAttributes(program) {
    program.attributeLocations.forEach((location, { name, type }) => {
      if (!this.attributes[name]) {
        console.warn(`active attribute ${name} not being supplied`);
        return;
      }
      const attr = this.attributes[name];
      this.gl.bindBuffer(attr.target, attr.buffer);
      this.glState.boundBuffer = attr.buffer;
      let numLoc = 1;
      if (type === 35674) numLoc = 2;
      if (type === 35675) numLoc = 3;
      if (type === 35676) numLoc = 4;
      const size = attr.size / numLoc;
      const stride = numLoc === 1 ? 0 : numLoc * numLoc * 4;
      const offset = numLoc === 1 ? 0 : numLoc * 4;
      for (let i5 = 0; i5 < numLoc; i5++) {
        this.gl.vertexAttribPointer(location + i5, size, attr.type, attr.normalized, attr.stride + stride, attr.offset + i5 * offset);
        this.gl.enableVertexAttribArray(location + i5);
        this.gl.renderer.vertexAttribDivisor(location + i5, attr.divisor);
      }
    });
    if (this.attributes.index) this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, this.attributes.index.buffer);
  }
  draw({ program, mode = this.gl.TRIANGLES }) {
    if (this.gl.renderer.currentGeometry !== `${this.id}_${program.attributeOrder}`) {
      if (!this.VAOs[program.attributeOrder]) this.createVAO(program);
      this.gl.renderer.bindVertexArray(this.VAOs[program.attributeOrder]);
      this.gl.renderer.currentGeometry = `${this.id}_${program.attributeOrder}`;
    }
    program.attributeLocations.forEach((location, { name }) => {
      const attr = this.attributes[name];
      if (attr.needsUpdate) this.updateAttribute(attr);
    });
    let indexBytesPerElement = 2;
    if (this.attributes.index?.type === this.gl.UNSIGNED_INT) indexBytesPerElement = 4;
    if (this.isInstanced) {
      if (this.attributes.index) {
        this.gl.renderer.drawElementsInstanced(
          mode,
          this.drawRange.count,
          this.attributes.index.type,
          this.attributes.index.offset + this.drawRange.start * indexBytesPerElement,
          this.instancedCount
        );
      } else {
        this.gl.renderer.drawArraysInstanced(mode, this.drawRange.start, this.drawRange.count, this.instancedCount);
      }
    } else {
      if (this.attributes.index) {
        this.gl.drawElements(
          mode,
          this.drawRange.count,
          this.attributes.index.type,
          this.attributes.index.offset + this.drawRange.start * indexBytesPerElement
        );
      } else {
        this.gl.drawArrays(mode, this.drawRange.start, this.drawRange.count);
      }
    }
  }
  getPosition() {
    const attr = this.attributes.position;
    if (attr.data) return attr;
    if (isBoundsWarned) return;
    console.warn("No position buffer data found to compute bounds");
    return isBoundsWarned = true;
  }
  computeBoundingBox(attr) {
    if (!attr) attr = this.getPosition();
    const array = attr.data;
    const stride = attr.size;
    if (!this.bounds) {
      this.bounds = {
        min: new Vec3(),
        max: new Vec3(),
        center: new Vec3(),
        scale: new Vec3(),
        radius: Infinity
      };
    }
    const min = this.bounds.min;
    const max = this.bounds.max;
    const center = this.bounds.center;
    const scale5 = this.bounds.scale;
    min.set(Infinity);
    max.set(-Infinity);
    for (let i5 = 0, l3 = array.length; i5 < l3; i5 += stride) {
      const x2 = array[i5];
      const y3 = array[i5 + 1];
      const z2 = array[i5 + 2];
      min.x = Math.min(x2, min.x);
      min.y = Math.min(y3, min.y);
      min.z = Math.min(z2, min.z);
      max.x = Math.max(x2, max.x);
      max.y = Math.max(y3, max.y);
      max.z = Math.max(z2, max.z);
    }
    scale5.sub(max, min);
    center.add(min, max).divide(2);
  }
  computeBoundingSphere(attr) {
    if (!attr) attr = this.getPosition();
    const array = attr.data;
    const stride = attr.size;
    if (!this.bounds) this.computeBoundingBox(attr);
    let maxRadiusSq = 0;
    for (let i5 = 0, l3 = array.length; i5 < l3; i5 += stride) {
      tempVec3.fromArray(array, i5);
      maxRadiusSq = Math.max(maxRadiusSq, this.bounds.center.squaredDistance(tempVec3));
    }
    this.bounds.radius = Math.sqrt(maxRadiusSq);
  }
  remove() {
    for (let key in this.VAOs) {
      this.gl.renderer.deleteVertexArray(this.VAOs[key]);
      delete this.VAOs[key];
    }
    for (let key in this.attributes) {
      this.gl.deleteBuffer(this.attributes[key].buffer);
      delete this.attributes[key];
    }
  }
};

// node_modules/ogl/src/core/Program.js
var ID2 = 1;
var arrayCacheF32 = {};
var Program = class {
  constructor(gl, {
    vertex,
    fragment,
    uniforms = {},
    transparent = false,
    cullFace = gl.BACK,
    frontFace = gl.CCW,
    depthTest = true,
    depthWrite = true,
    depthFunc = gl.LEQUAL
  } = {}) {
    if (!gl.canvas) console.error("gl not passed as first argument to Program");
    this.gl = gl;
    this.uniforms = uniforms;
    this.id = ID2++;
    if (!vertex) console.warn("vertex shader not supplied");
    if (!fragment) console.warn("fragment shader not supplied");
    this.transparent = transparent;
    this.cullFace = cullFace;
    this.frontFace = frontFace;
    this.depthTest = depthTest;
    this.depthWrite = depthWrite;
    this.depthFunc = depthFunc;
    this.blendFunc = {};
    this.blendEquation = {};
    this.stencilFunc = {};
    this.stencilOp = {};
    if (this.transparent && !this.blendFunc.src) {
      if (this.gl.renderer.premultipliedAlpha) this.setBlendFunc(this.gl.ONE, this.gl.ONE_MINUS_SRC_ALPHA);
      else this.setBlendFunc(this.gl.SRC_ALPHA, this.gl.ONE_MINUS_SRC_ALPHA);
    }
    this.vertexShader = gl.createShader(gl.VERTEX_SHADER);
    this.fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
    this.program = gl.createProgram();
    gl.attachShader(this.program, this.vertexShader);
    gl.attachShader(this.program, this.fragmentShader);
    this.setShaders({ vertex, fragment });
  }
  setShaders({ vertex, fragment }) {
    if (vertex) {
      this.gl.shaderSource(this.vertexShader, vertex);
      this.gl.compileShader(this.vertexShader);
      if (this.gl.getShaderInfoLog(this.vertexShader) !== "") {
        console.warn(`${this.gl.getShaderInfoLog(this.vertexShader)}
Vertex Shader
${addLineNumbers(vertex)}`);
      }
    }
    if (fragment) {
      this.gl.shaderSource(this.fragmentShader, fragment);
      this.gl.compileShader(this.fragmentShader);
      if (this.gl.getShaderInfoLog(this.fragmentShader) !== "") {
        console.warn(`${this.gl.getShaderInfoLog(this.fragmentShader)}
Fragment Shader
${addLineNumbers(fragment)}`);
      }
    }
    this.gl.linkProgram(this.program);
    if (!this.gl.getProgramParameter(this.program, this.gl.LINK_STATUS)) {
      return console.warn(this.gl.getProgramInfoLog(this.program));
    }
    this.uniformLocations = /* @__PURE__ */ new Map();
    let numUniforms = this.gl.getProgramParameter(this.program, this.gl.ACTIVE_UNIFORMS);
    for (let uIndex = 0; uIndex < numUniforms; uIndex++) {
      let uniform = this.gl.getActiveUniform(this.program, uIndex);
      this.uniformLocations.set(uniform, this.gl.getUniformLocation(this.program, uniform.name));
      const split = uniform.name.match(/(\w+)/g);
      uniform.uniformName = split[0];
      uniform.nameComponents = split.slice(1);
    }
    this.attributeLocations = /* @__PURE__ */ new Map();
    const locations = [];
    const numAttribs = this.gl.getProgramParameter(this.program, this.gl.ACTIVE_ATTRIBUTES);
    for (let aIndex = 0; aIndex < numAttribs; aIndex++) {
      const attribute = this.gl.getActiveAttrib(this.program, aIndex);
      const location = this.gl.getAttribLocation(this.program, attribute.name);
      if (location === -1) continue;
      locations[location] = attribute.name;
      this.attributeLocations.set(attribute, location);
    }
    this.attributeOrder = locations.join("");
  }
  setBlendFunc(src, dst, srcAlpha, dstAlpha) {
    this.blendFunc.src = src;
    this.blendFunc.dst = dst;
    this.blendFunc.srcAlpha = srcAlpha;
    this.blendFunc.dstAlpha = dstAlpha;
    if (src) this.transparent = true;
  }
  setBlendEquation(modeRGB, modeAlpha) {
    this.blendEquation.modeRGB = modeRGB;
    this.blendEquation.modeAlpha = modeAlpha;
  }
  setStencilFunc(func, ref, mask) {
    this.stencilRef = ref;
    this.stencilFunc.func = func;
    this.stencilFunc.ref = ref;
    this.stencilFunc.mask = mask;
  }
  setStencilOp(stencilFail, depthFail, depthPass) {
    this.stencilOp.stencilFail = stencilFail;
    this.stencilOp.depthFail = depthFail;
    this.stencilOp.depthPass = depthPass;
  }
  applyState() {
    if (this.depthTest) this.gl.renderer.enable(this.gl.DEPTH_TEST);
    else this.gl.renderer.disable(this.gl.DEPTH_TEST);
    if (this.cullFace) this.gl.renderer.enable(this.gl.CULL_FACE);
    else this.gl.renderer.disable(this.gl.CULL_FACE);
    if (this.blendFunc.src) this.gl.renderer.enable(this.gl.BLEND);
    else this.gl.renderer.disable(this.gl.BLEND);
    if (this.cullFace) this.gl.renderer.setCullFace(this.cullFace);
    this.gl.renderer.setFrontFace(this.frontFace);
    this.gl.renderer.setDepthMask(this.depthWrite);
    this.gl.renderer.setDepthFunc(this.depthFunc);
    if (this.blendFunc.src) this.gl.renderer.setBlendFunc(this.blendFunc.src, this.blendFunc.dst, this.blendFunc.srcAlpha, this.blendFunc.dstAlpha);
    this.gl.renderer.setBlendEquation(this.blendEquation.modeRGB, this.blendEquation.modeAlpha);
    if (this.stencilFunc.func || this.stencilOp.stencilFail) this.gl.renderer.enable(this.gl.STENCIL_TEST);
    else this.gl.renderer.disable(this.gl.STENCIL_TEST);
    this.gl.renderer.setStencilFunc(this.stencilFunc.func, this.stencilFunc.ref, this.stencilFunc.mask);
    this.gl.renderer.setStencilOp(this.stencilOp.stencilFail, this.stencilOp.depthFail, this.stencilOp.depthPass);
  }
  use({ flipFaces = false } = {}) {
    let textureUnit = -1;
    const programActive = this.gl.renderer.state.currentProgram === this.id;
    if (!programActive) {
      this.gl.useProgram(this.program);
      this.gl.renderer.state.currentProgram = this.id;
    }
    this.uniformLocations.forEach((location, activeUniform) => {
      let uniform = this.uniforms[activeUniform.uniformName];
      for (const component of activeUniform.nameComponents) {
        if (!uniform) break;
        if (component in uniform) {
          uniform = uniform[component];
        } else if (Array.isArray(uniform.value)) {
          break;
        } else {
          uniform = void 0;
          break;
        }
      }
      if (!uniform) {
        return warn(`Active uniform ${activeUniform.name} has not been supplied`);
      }
      if (uniform && uniform.value === void 0) {
        return warn(`${activeUniform.name} uniform is missing a value parameter`);
      }
      if (uniform.value.texture) {
        textureUnit = textureUnit + 1;
        uniform.value.update(textureUnit);
        return setUniform(this.gl, activeUniform.type, location, textureUnit);
      }
      if (uniform.value.length && uniform.value[0].texture) {
        const textureUnits = [];
        uniform.value.forEach((value) => {
          textureUnit = textureUnit + 1;
          value.update(textureUnit);
          textureUnits.push(textureUnit);
        });
        return setUniform(this.gl, activeUniform.type, location, textureUnits);
      }
      setUniform(this.gl, activeUniform.type, location, uniform.value);
    });
    this.applyState();
    if (flipFaces) this.gl.renderer.setFrontFace(this.frontFace === this.gl.CCW ? this.gl.CW : this.gl.CCW);
  }
  remove() {
    this.gl.deleteProgram(this.program);
  }
};
function setUniform(gl, type, location, value) {
  value = value.length ? flatten(value) : value;
  const setValue = gl.renderer.state.uniformLocations.get(location);
  if (value.length) {
    if (setValue === void 0 || setValue.length !== value.length) {
      gl.renderer.state.uniformLocations.set(location, value.slice(0));
    } else {
      if (arraysEqual(setValue, value)) return;
      setValue.set ? setValue.set(value) : setArray(setValue, value);
      gl.renderer.state.uniformLocations.set(location, setValue);
    }
  } else {
    if (setValue === value) return;
    gl.renderer.state.uniformLocations.set(location, value);
  }
  switch (type) {
    case 5126:
      return value.length ? gl.uniform1fv(location, value) : gl.uniform1f(location, value);
    // FLOAT
    case 35664:
      return gl.uniform2fv(location, value);
    // FLOAT_VEC2
    case 35665:
      return gl.uniform3fv(location, value);
    // FLOAT_VEC3
    case 35666:
      return gl.uniform4fv(location, value);
    // FLOAT_VEC4
    case 35670:
    // BOOL
    case 5124:
    // INT
    case 35678:
    // SAMPLER_2D
    case 36306:
    // U_SAMPLER_2D
    case 35680:
    // SAMPLER_CUBE
    case 36289:
      return value.length ? gl.uniform1iv(location, value) : gl.uniform1i(location, value);
    // SAMPLER_CUBE
    case 35671:
    // BOOL_VEC2
    case 35667:
      return gl.uniform2iv(location, value);
    // INT_VEC2
    case 35672:
    // BOOL_VEC3
    case 35668:
      return gl.uniform3iv(location, value);
    // INT_VEC3
    case 35673:
    // BOOL_VEC4
    case 35669:
      return gl.uniform4iv(location, value);
    // INT_VEC4
    case 35674:
      return gl.uniformMatrix2fv(location, false, value);
    // FLOAT_MAT2
    case 35675:
      return gl.uniformMatrix3fv(location, false, value);
    // FLOAT_MAT3
    case 35676:
      return gl.uniformMatrix4fv(location, false, value);
  }
}
function addLineNumbers(string) {
  let lines = string.split("\n");
  for (let i5 = 0; i5 < lines.length; i5++) {
    lines[i5] = i5 + 1 + ": " + lines[i5];
  }
  return lines.join("\n");
}
function flatten(a3) {
  const arrayLen = a3.length;
  const valueLen = a3[0].length;
  if (valueLen === void 0) return a3;
  const length3 = arrayLen * valueLen;
  let value = arrayCacheF32[length3];
  if (!value) arrayCacheF32[length3] = value = new Float32Array(length3);
  for (let i5 = 0; i5 < arrayLen; i5++) value.set(a3[i5], i5 * valueLen);
  return value;
}
function arraysEqual(a3, b3) {
  if (a3.length !== b3.length) return false;
  for (let i5 = 0, l3 = a3.length; i5 < l3; i5++) {
    if (a3[i5] !== b3[i5]) return false;
  }
  return true;
}
function setArray(a3, b3) {
  for (let i5 = 0, l3 = a3.length; i5 < l3; i5++) {
    a3[i5] = b3[i5];
  }
}
var warnCount = 0;
function warn(message) {
  if (warnCount > 100) return;
  console.warn(message);
  warnCount++;
  if (warnCount > 100) console.warn("More than 100 program warnings - stopping logs.");
}

// node_modules/ogl/src/core/Renderer.js
var tempVec32 = /* @__PURE__ */ new Vec3();
var ID3 = 1;
var Renderer = class {
  constructor({
    canvas = document.createElement("canvas"),
    width = 300,
    height = 150,
    dpr = 1,
    alpha = false,
    depth = true,
    stencil = false,
    antialias = false,
    premultipliedAlpha = false,
    preserveDrawingBuffer = false,
    powerPreference = "default",
    autoClear = true,
    webgl = 2
  } = {}) {
    const attributes = { alpha, depth, stencil, antialias, premultipliedAlpha, preserveDrawingBuffer, powerPreference };
    this.dpr = dpr;
    this.alpha = alpha;
    this.color = true;
    this.depth = depth;
    this.stencil = stencil;
    this.premultipliedAlpha = premultipliedAlpha;
    this.autoClear = autoClear;
    this.id = ID3++;
    if (webgl === 2) this.gl = canvas.getContext("webgl2", attributes);
    this.isWebgl2 = !!this.gl;
    if (!this.gl) this.gl = canvas.getContext("webgl", attributes);
    if (!this.gl) console.error("unable to create webgl context");
    this.gl.renderer = this;
    this.setSize(width, height);
    this.state = {};
    this.state.blendFunc = { src: this.gl.ONE, dst: this.gl.ZERO };
    this.state.blendEquation = { modeRGB: this.gl.FUNC_ADD };
    this.state.cullFace = false;
    this.state.frontFace = this.gl.CCW;
    this.state.depthMask = true;
    this.state.depthFunc = this.gl.LEQUAL;
    this.state.premultiplyAlpha = false;
    this.state.flipY = false;
    this.state.unpackAlignment = 4;
    this.state.framebuffer = null;
    this.state.viewport = { x: 0, y: 0, width: null, height: null };
    this.state.textureUnits = [];
    this.state.activeTextureUnit = 0;
    this.state.boundBuffer = null;
    this.state.uniformLocations = /* @__PURE__ */ new Map();
    this.state.currentProgram = null;
    this.extensions = {};
    if (this.isWebgl2) {
      this.getExtension("EXT_color_buffer_float");
      this.getExtension("OES_texture_float_linear");
    } else {
      this.getExtension("OES_texture_float");
      this.getExtension("OES_texture_float_linear");
      this.getExtension("OES_texture_half_float");
      this.getExtension("OES_texture_half_float_linear");
      this.getExtension("OES_element_index_uint");
      this.getExtension("OES_standard_derivatives");
      this.getExtension("EXT_sRGB");
      this.getExtension("WEBGL_depth_texture");
      this.getExtension("WEBGL_draw_buffers");
    }
    this.getExtension("WEBGL_compressed_texture_astc");
    this.getExtension("EXT_texture_compression_bptc");
    this.getExtension("WEBGL_compressed_texture_s3tc");
    this.getExtension("WEBGL_compressed_texture_etc1");
    this.getExtension("WEBGL_compressed_texture_pvrtc");
    this.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
    this.vertexAttribDivisor = this.getExtension("ANGLE_instanced_arrays", "vertexAttribDivisor", "vertexAttribDivisorANGLE");
    this.drawArraysInstanced = this.getExtension("ANGLE_instanced_arrays", "drawArraysInstanced", "drawArraysInstancedANGLE");
    this.drawElementsInstanced = this.getExtension("ANGLE_instanced_arrays", "drawElementsInstanced", "drawElementsInstancedANGLE");
    this.createVertexArray = this.getExtension("OES_vertex_array_object", "createVertexArray", "createVertexArrayOES");
    this.bindVertexArray = this.getExtension("OES_vertex_array_object", "bindVertexArray", "bindVertexArrayOES");
    this.deleteVertexArray = this.getExtension("OES_vertex_array_object", "deleteVertexArray", "deleteVertexArrayOES");
    this.drawBuffers = this.getExtension("WEBGL_draw_buffers", "drawBuffers", "drawBuffersWEBGL");
    this.parameters = {};
    this.parameters.maxTextureUnits = this.gl.getParameter(this.gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    this.parameters.maxAnisotropy = this.getExtension("EXT_texture_filter_anisotropic") ? this.gl.getParameter(this.getExtension("EXT_texture_filter_anisotropic").MAX_TEXTURE_MAX_ANISOTROPY_EXT) : 0;
  }
  setSize(width, height) {
    this.width = width;
    this.height = height;
    this.gl.canvas.width = width * this.dpr;
    this.gl.canvas.height = height * this.dpr;
    if (!this.gl.canvas.style) return;
    Object.assign(this.gl.canvas.style, {
      width: width + "px",
      height: height + "px"
    });
  }
  setViewport(width, height, x2 = 0, y3 = 0) {
    if (this.state.viewport.width === width && this.state.viewport.height === height) return;
    this.state.viewport.width = width;
    this.state.viewport.height = height;
    this.state.viewport.x = x2;
    this.state.viewport.y = y3;
    this.gl.viewport(x2, y3, width, height);
  }
  setScissor(width, height, x2 = 0, y3 = 0) {
    this.gl.scissor(x2, y3, width, height);
  }
  enable(id) {
    if (this.state[id] === true) return;
    this.gl.enable(id);
    this.state[id] = true;
  }
  disable(id) {
    if (this.state[id] === false) return;
    this.gl.disable(id);
    this.state[id] = false;
  }
  setBlendFunc(src, dst, srcAlpha, dstAlpha) {
    if (this.state.blendFunc.src === src && this.state.blendFunc.dst === dst && this.state.blendFunc.srcAlpha === srcAlpha && this.state.blendFunc.dstAlpha === dstAlpha)
      return;
    this.state.blendFunc.src = src;
    this.state.blendFunc.dst = dst;
    this.state.blendFunc.srcAlpha = srcAlpha;
    this.state.blendFunc.dstAlpha = dstAlpha;
    if (srcAlpha !== void 0) this.gl.blendFuncSeparate(src, dst, srcAlpha, dstAlpha);
    else this.gl.blendFunc(src, dst);
  }
  setBlendEquation(modeRGB, modeAlpha) {
    modeRGB = modeRGB || this.gl.FUNC_ADD;
    if (this.state.blendEquation.modeRGB === modeRGB && this.state.blendEquation.modeAlpha === modeAlpha) return;
    this.state.blendEquation.modeRGB = modeRGB;
    this.state.blendEquation.modeAlpha = modeAlpha;
    if (modeAlpha !== void 0) this.gl.blendEquationSeparate(modeRGB, modeAlpha);
    else this.gl.blendEquation(modeRGB);
  }
  setCullFace(value) {
    if (this.state.cullFace === value) return;
    this.state.cullFace = value;
    this.gl.cullFace(value);
  }
  setFrontFace(value) {
    if (this.state.frontFace === value) return;
    this.state.frontFace = value;
    this.gl.frontFace(value);
  }
  setDepthMask(value) {
    if (this.state.depthMask === value) return;
    this.state.depthMask = value;
    this.gl.depthMask(value);
  }
  setDepthFunc(value) {
    if (this.state.depthFunc === value) return;
    this.state.depthFunc = value;
    this.gl.depthFunc(value);
  }
  setStencilMask(value) {
    if (this.state.stencilMask === value) return;
    this.state.stencilMask = value;
    this.gl.stencilMask(value);
  }
  setStencilFunc(func, ref, mask) {
    if (this.state.stencilFunc === func && this.state.stencilRef === ref && this.state.stencilFuncMask === mask) return;
    this.state.stencilFunc = func || this.gl.ALWAYS;
    this.state.stencilRef = ref || 0;
    this.state.stencilFuncMask = mask || 0;
    this.gl.stencilFunc(func || this.gl.ALWAYS, ref || 0, mask || 0);
  }
  setStencilOp(stencilFail, depthFail, depthPass) {
    if (this.state.stencilFail === stencilFail && this.state.stencilDepthFail === depthFail && this.state.stencilDepthPass === depthPass) return;
    this.state.stencilFail = stencilFail;
    this.state.stencilDepthFail = depthFail;
    this.state.stencilDepthPass = depthPass;
    this.gl.stencilOp(stencilFail, depthFail, depthPass);
  }
  activeTexture(value) {
    if (this.state.activeTextureUnit === value) return;
    this.state.activeTextureUnit = value;
    this.gl.activeTexture(this.gl.TEXTURE0 + value);
  }
  bindFramebuffer({ target = this.gl.FRAMEBUFFER, buffer = null } = {}) {
    if (this.state.framebuffer === buffer) return;
    this.state.framebuffer = buffer;
    this.gl.bindFramebuffer(target, buffer);
  }
  getExtension(extension, webgl2Func, extFunc) {
    if (webgl2Func && this.gl[webgl2Func]) return this.gl[webgl2Func].bind(this.gl);
    if (!this.extensions[extension]) {
      this.extensions[extension] = this.gl.getExtension(extension);
    }
    if (!webgl2Func) return this.extensions[extension];
    if (!this.extensions[extension]) return null;
    return this.extensions[extension][extFunc].bind(this.extensions[extension]);
  }
  sortOpaque(a3, b3) {
    if (a3.renderOrder !== b3.renderOrder) {
      return a3.renderOrder - b3.renderOrder;
    } else if (a3.program.id !== b3.program.id) {
      return a3.program.id - b3.program.id;
    } else if (a3.zDepth !== b3.zDepth) {
      return a3.zDepth - b3.zDepth;
    } else {
      return b3.id - a3.id;
    }
  }
  sortTransparent(a3, b3) {
    if (a3.renderOrder !== b3.renderOrder) {
      return a3.renderOrder - b3.renderOrder;
    }
    if (a3.zDepth !== b3.zDepth) {
      return b3.zDepth - a3.zDepth;
    } else {
      return b3.id - a3.id;
    }
  }
  sortUI(a3, b3) {
    if (a3.renderOrder !== b3.renderOrder) {
      return a3.renderOrder - b3.renderOrder;
    } else if (a3.program.id !== b3.program.id) {
      return a3.program.id - b3.program.id;
    } else {
      return b3.id - a3.id;
    }
  }
  getRenderList({ scene, camera, frustumCull, sort }) {
    let renderList = [];
    if (camera && frustumCull) camera.updateFrustum();
    scene.traverse((node) => {
      if (!node.visible) return true;
      if (!node.draw) return;
      if (frustumCull && node.frustumCulled && camera) {
        if (!camera.frustumIntersectsMesh(node)) return;
      }
      renderList.push(node);
    });
    if (sort) {
      const opaque = [];
      const transparent = [];
      const ui = [];
      renderList.forEach((node) => {
        if (!node.program.transparent) {
          opaque.push(node);
        } else if (node.program.depthTest) {
          transparent.push(node);
        } else {
          ui.push(node);
        }
        node.zDepth = 0;
        if (node.renderOrder !== 0 || !node.program.depthTest || !camera) return;
        node.worldMatrix.getTranslation(tempVec32);
        tempVec32.applyMatrix4(camera.projectionViewMatrix);
        node.zDepth = tempVec32.z;
      });
      opaque.sort(this.sortOpaque);
      transparent.sort(this.sortTransparent);
      ui.sort(this.sortUI);
      renderList = opaque.concat(transparent, ui);
    }
    return renderList;
  }
  render({ scene, camera, target = null, update = true, sort = true, frustumCull = true, clear }) {
    if (target === null) {
      this.bindFramebuffer();
      this.setViewport(this.width * this.dpr, this.height * this.dpr);
    } else {
      this.bindFramebuffer(target);
      this.setViewport(target.width, target.height);
    }
    if (clear || this.autoClear && clear !== false) {
      if (this.depth && (!target || target.depth)) {
        this.enable(this.gl.DEPTH_TEST);
        this.setDepthMask(true);
      }
      if (this.stencil || (!target || target.stencil)) {
        this.enable(this.gl.STENCIL_TEST);
        this.setStencilMask(255);
      }
      this.gl.clear(
        (this.color ? this.gl.COLOR_BUFFER_BIT : 0) | (this.depth ? this.gl.DEPTH_BUFFER_BIT : 0) | (this.stencil ? this.gl.STENCIL_BUFFER_BIT : 0)
      );
    }
    if (update) scene.updateMatrixWorld();
    if (camera) camera.updateMatrixWorld();
    const renderList = this.getRenderList({ scene, camera, frustumCull, sort });
    renderList.forEach((node) => {
      node.draw({ camera });
    });
  }
};

// node_modules/ogl/src/math/functions/Vec4Func.js
function copy2(out, a3) {
  out[0] = a3[0];
  out[1] = a3[1];
  out[2] = a3[2];
  out[3] = a3[3];
  return out;
}
function set2(out, x2, y3, z2, w2) {
  out[0] = x2;
  out[1] = y3;
  out[2] = z2;
  out[3] = w2;
  return out;
}
function normalize2(out, a3) {
  let x2 = a3[0];
  let y3 = a3[1];
  let z2 = a3[2];
  let w2 = a3[3];
  let len = x2 * x2 + y3 * y3 + z2 * z2 + w2 * w2;
  if (len > 0) {
    len = 1 / Math.sqrt(len);
  }
  out[0] = x2 * len;
  out[1] = y3 * len;
  out[2] = z2 * len;
  out[3] = w2 * len;
  return out;
}
function dot2(a3, b3) {
  return a3[0] * b3[0] + a3[1] * b3[1] + a3[2] * b3[2] + a3[3] * b3[3];
}

// node_modules/ogl/src/math/functions/QuatFunc.js
function identity(out) {
  out[0] = 0;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  return out;
}
function setAxisAngle(out, axis, rad) {
  rad = rad * 0.5;
  let s4 = Math.sin(rad);
  out[0] = s4 * axis[0];
  out[1] = s4 * axis[1];
  out[2] = s4 * axis[2];
  out[3] = Math.cos(rad);
  return out;
}
function multiply2(out, a3, b3) {
  let ax = a3[0], ay = a3[1], az = a3[2], aw = a3[3];
  let bx = b3[0], by = b3[1], bz = b3[2], bw = b3[3];
  out[0] = ax * bw + aw * bx + ay * bz - az * by;
  out[1] = ay * bw + aw * by + az * bx - ax * bz;
  out[2] = az * bw + aw * bz + ax * by - ay * bx;
  out[3] = aw * bw - ax * bx - ay * by - az * bz;
  return out;
}
function rotateX(out, a3, rad) {
  rad *= 0.5;
  let ax = a3[0], ay = a3[1], az = a3[2], aw = a3[3];
  let bx = Math.sin(rad), bw = Math.cos(rad);
  out[0] = ax * bw + aw * bx;
  out[1] = ay * bw + az * bx;
  out[2] = az * bw - ay * bx;
  out[3] = aw * bw - ax * bx;
  return out;
}
function rotateY(out, a3, rad) {
  rad *= 0.5;
  let ax = a3[0], ay = a3[1], az = a3[2], aw = a3[3];
  let by = Math.sin(rad), bw = Math.cos(rad);
  out[0] = ax * bw - az * by;
  out[1] = ay * bw + aw * by;
  out[2] = az * bw + ax * by;
  out[3] = aw * bw - ay * by;
  return out;
}
function rotateZ(out, a3, rad) {
  rad *= 0.5;
  let ax = a3[0], ay = a3[1], az = a3[2], aw = a3[3];
  let bz = Math.sin(rad), bw = Math.cos(rad);
  out[0] = ax * bw + ay * bz;
  out[1] = ay * bw - ax * bz;
  out[2] = az * bw + aw * bz;
  out[3] = aw * bw - az * bz;
  return out;
}
function slerp(out, a3, b3, t4) {
  let ax = a3[0], ay = a3[1], az = a3[2], aw = a3[3];
  let bx = b3[0], by = b3[1], bz = b3[2], bw = b3[3];
  let omega, cosom, sinom, scale0, scale1;
  cosom = ax * bx + ay * by + az * bz + aw * bw;
  if (cosom < 0) {
    cosom = -cosom;
    bx = -bx;
    by = -by;
    bz = -bz;
    bw = -bw;
  }
  if (1 - cosom > 1e-6) {
    omega = Math.acos(cosom);
    sinom = Math.sin(omega);
    scale0 = Math.sin((1 - t4) * omega) / sinom;
    scale1 = Math.sin(t4 * omega) / sinom;
  } else {
    scale0 = 1 - t4;
    scale1 = t4;
  }
  out[0] = scale0 * ax + scale1 * bx;
  out[1] = scale0 * ay + scale1 * by;
  out[2] = scale0 * az + scale1 * bz;
  out[3] = scale0 * aw + scale1 * bw;
  return out;
}
function invert(out, a3) {
  let a0 = a3[0], a1 = a3[1], a22 = a3[2], a32 = a3[3];
  let dot4 = a0 * a0 + a1 * a1 + a22 * a22 + a32 * a32;
  let invDot = dot4 ? 1 / dot4 : 0;
  out[0] = -a0 * invDot;
  out[1] = -a1 * invDot;
  out[2] = -a22 * invDot;
  out[3] = a32 * invDot;
  return out;
}
function conjugate(out, a3) {
  out[0] = -a3[0];
  out[1] = -a3[1];
  out[2] = -a3[2];
  out[3] = a3[3];
  return out;
}
function fromMat3(out, m2) {
  let fTrace = m2[0] + m2[4] + m2[8];
  let fRoot;
  if (fTrace > 0) {
    fRoot = Math.sqrt(fTrace + 1);
    out[3] = 0.5 * fRoot;
    fRoot = 0.5 / fRoot;
    out[0] = (m2[5] - m2[7]) * fRoot;
    out[1] = (m2[6] - m2[2]) * fRoot;
    out[2] = (m2[1] - m2[3]) * fRoot;
  } else {
    let i5 = 0;
    if (m2[4] > m2[0]) i5 = 1;
    if (m2[8] > m2[i5 * 3 + i5]) i5 = 2;
    let j = (i5 + 1) % 3;
    let k2 = (i5 + 2) % 3;
    fRoot = Math.sqrt(m2[i5 * 3 + i5] - m2[j * 3 + j] - m2[k2 * 3 + k2] + 1);
    out[i5] = 0.5 * fRoot;
    fRoot = 0.5 / fRoot;
    out[3] = (m2[j * 3 + k2] - m2[k2 * 3 + j]) * fRoot;
    out[j] = (m2[j * 3 + i5] + m2[i5 * 3 + j]) * fRoot;
    out[k2] = (m2[k2 * 3 + i5] + m2[i5 * 3 + k2]) * fRoot;
  }
  return out;
}
function fromEuler(out, euler, order = "YXZ") {
  let sx = Math.sin(euler[0] * 0.5);
  let cx = Math.cos(euler[0] * 0.5);
  let sy = Math.sin(euler[1] * 0.5);
  let cy = Math.cos(euler[1] * 0.5);
  let sz = Math.sin(euler[2] * 0.5);
  let cz = Math.cos(euler[2] * 0.5);
  if (order === "XYZ") {
    out[0] = sx * cy * cz + cx * sy * sz;
    out[1] = cx * sy * cz - sx * cy * sz;
    out[2] = cx * cy * sz + sx * sy * cz;
    out[3] = cx * cy * cz - sx * sy * sz;
  } else if (order === "YXZ") {
    out[0] = sx * cy * cz + cx * sy * sz;
    out[1] = cx * sy * cz - sx * cy * sz;
    out[2] = cx * cy * sz - sx * sy * cz;
    out[3] = cx * cy * cz + sx * sy * sz;
  } else if (order === "ZXY") {
    out[0] = sx * cy * cz - cx * sy * sz;
    out[1] = cx * sy * cz + sx * cy * sz;
    out[2] = cx * cy * sz + sx * sy * cz;
    out[3] = cx * cy * cz - sx * sy * sz;
  } else if (order === "ZYX") {
    out[0] = sx * cy * cz - cx * sy * sz;
    out[1] = cx * sy * cz + sx * cy * sz;
    out[2] = cx * cy * sz - sx * sy * cz;
    out[3] = cx * cy * cz + sx * sy * sz;
  } else if (order === "YZX") {
    out[0] = sx * cy * cz + cx * sy * sz;
    out[1] = cx * sy * cz + sx * cy * sz;
    out[2] = cx * cy * sz - sx * sy * cz;
    out[3] = cx * cy * cz - sx * sy * sz;
  } else if (order === "XZY") {
    out[0] = sx * cy * cz - cx * sy * sz;
    out[1] = cx * sy * cz - sx * cy * sz;
    out[2] = cx * cy * sz + sx * sy * cz;
    out[3] = cx * cy * cz + sx * sy * sz;
  }
  return out;
}
var copy3 = copy2;
var set3 = set2;
var dot3 = dot2;
var normalize3 = normalize2;

// node_modules/ogl/src/math/Quat.js
var Quat = class extends Array {
  constructor(x2 = 0, y3 = 0, z2 = 0, w2 = 1) {
    super(x2, y3, z2, w2);
    this.onChange = () => {
    };
    this._target = this;
    const triggerProps = ["0", "1", "2", "3"];
    return new Proxy(this, {
      set(target, property) {
        const success = Reflect.set(...arguments);
        if (success && triggerProps.includes(property)) target.onChange();
        return success;
      }
    });
  }
  get x() {
    return this[0];
  }
  get y() {
    return this[1];
  }
  get z() {
    return this[2];
  }
  get w() {
    return this[3];
  }
  set x(v2) {
    this._target[0] = v2;
    this.onChange();
  }
  set y(v2) {
    this._target[1] = v2;
    this.onChange();
  }
  set z(v2) {
    this._target[2] = v2;
    this.onChange();
  }
  set w(v2) {
    this._target[3] = v2;
    this.onChange();
  }
  identity() {
    identity(this._target);
    this.onChange();
    return this;
  }
  set(x2, y3, z2, w2) {
    if (x2.length) return this.copy(x2);
    set3(this._target, x2, y3, z2, w2);
    this.onChange();
    return this;
  }
  rotateX(a3) {
    rotateX(this._target, this._target, a3);
    this.onChange();
    return this;
  }
  rotateY(a3) {
    rotateY(this._target, this._target, a3);
    this.onChange();
    return this;
  }
  rotateZ(a3) {
    rotateZ(this._target, this._target, a3);
    this.onChange();
    return this;
  }
  inverse(q = this._target) {
    invert(this._target, q);
    this.onChange();
    return this;
  }
  conjugate(q = this._target) {
    conjugate(this._target, q);
    this.onChange();
    return this;
  }
  copy(q) {
    copy3(this._target, q);
    this.onChange();
    return this;
  }
  normalize(q = this._target) {
    normalize3(this._target, q);
    this.onChange();
    return this;
  }
  multiply(qA, qB) {
    if (qB) {
      multiply2(this._target, qA, qB);
    } else {
      multiply2(this._target, this._target, qA);
    }
    this.onChange();
    return this;
  }
  dot(v2) {
    return dot3(this._target, v2);
  }
  fromMatrix3(matrix3) {
    fromMat3(this._target, matrix3);
    this.onChange();
    return this;
  }
  fromEuler(euler, isInternal) {
    fromEuler(this._target, euler, euler.order);
    if (!isInternal) this.onChange();
    return this;
  }
  fromAxisAngle(axis, a3) {
    setAxisAngle(this._target, axis, a3);
    this.onChange();
    return this;
  }
  slerp(q, t4) {
    slerp(this._target, this._target, q, t4);
    this.onChange();
    return this;
  }
  fromArray(a3, o6 = 0) {
    this._target[0] = a3[o6];
    this._target[1] = a3[o6 + 1];
    this._target[2] = a3[o6 + 2];
    this._target[3] = a3[o6 + 3];
    this.onChange();
    return this;
  }
  toArray(a3 = [], o6 = 0) {
    a3[o6] = this[0];
    a3[o6 + 1] = this[1];
    a3[o6 + 2] = this[2];
    a3[o6 + 3] = this[3];
    return a3;
  }
};

// node_modules/ogl/src/math/functions/Mat4Func.js
var EPSILON = 1e-6;
function copy4(out, a3) {
  out[0] = a3[0];
  out[1] = a3[1];
  out[2] = a3[2];
  out[3] = a3[3];
  out[4] = a3[4];
  out[5] = a3[5];
  out[6] = a3[6];
  out[7] = a3[7];
  out[8] = a3[8];
  out[9] = a3[9];
  out[10] = a3[10];
  out[11] = a3[11];
  out[12] = a3[12];
  out[13] = a3[13];
  out[14] = a3[14];
  out[15] = a3[15];
  return out;
}
function set4(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m03;
  out[4] = m10;
  out[5] = m11;
  out[6] = m12;
  out[7] = m13;
  out[8] = m20;
  out[9] = m21;
  out[10] = m22;
  out[11] = m23;
  out[12] = m30;
  out[13] = m31;
  out[14] = m32;
  out[15] = m33;
  return out;
}
function identity2(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
function invert2(out, a3) {
  let a00 = a3[0], a01 = a3[1], a02 = a3[2], a03 = a3[3];
  let a10 = a3[4], a11 = a3[5], a12 = a3[6], a13 = a3[7];
  let a20 = a3[8], a21 = a3[9], a22 = a3[10], a23 = a3[11];
  let a30 = a3[12], a31 = a3[13], a32 = a3[14], a33 = a3[15];
  let b00 = a00 * a11 - a01 * a10;
  let b01 = a00 * a12 - a02 * a10;
  let b02 = a00 * a13 - a03 * a10;
  let b03 = a01 * a12 - a02 * a11;
  let b04 = a01 * a13 - a03 * a11;
  let b05 = a02 * a13 - a03 * a12;
  let b06 = a20 * a31 - a21 * a30;
  let b07 = a20 * a32 - a22 * a30;
  let b08 = a20 * a33 - a23 * a30;
  let b09 = a21 * a32 - a22 * a31;
  let b10 = a21 * a33 - a23 * a31;
  let b11 = a22 * a33 - a23 * a32;
  let det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
  if (!det) {
    return null;
  }
  det = 1 / det;
  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
  out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
  out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
  out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
  out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
  out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
  out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
  out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
  out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
  out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
  return out;
}
function determinant(a3) {
  let a00 = a3[0], a01 = a3[1], a02 = a3[2], a03 = a3[3];
  let a10 = a3[4], a11 = a3[5], a12 = a3[6], a13 = a3[7];
  let a20 = a3[8], a21 = a3[9], a22 = a3[10], a23 = a3[11];
  let a30 = a3[12], a31 = a3[13], a32 = a3[14], a33 = a3[15];
  let b00 = a00 * a11 - a01 * a10;
  let b01 = a00 * a12 - a02 * a10;
  let b02 = a00 * a13 - a03 * a10;
  let b03 = a01 * a12 - a02 * a11;
  let b04 = a01 * a13 - a03 * a11;
  let b05 = a02 * a13 - a03 * a12;
  let b06 = a20 * a31 - a21 * a30;
  let b07 = a20 * a32 - a22 * a30;
  let b08 = a20 * a33 - a23 * a30;
  let b09 = a21 * a32 - a22 * a31;
  let b10 = a21 * a33 - a23 * a31;
  let b11 = a22 * a33 - a23 * a32;
  return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
function multiply3(out, a3, b3) {
  let a00 = a3[0], a01 = a3[1], a02 = a3[2], a03 = a3[3];
  let a10 = a3[4], a11 = a3[5], a12 = a3[6], a13 = a3[7];
  let a20 = a3[8], a21 = a3[9], a22 = a3[10], a23 = a3[11];
  let a30 = a3[12], a31 = a3[13], a32 = a3[14], a33 = a3[15];
  let b0 = b3[0], b1 = b3[1], b22 = b3[2], b32 = b3[3];
  out[0] = b0 * a00 + b1 * a10 + b22 * a20 + b32 * a30;
  out[1] = b0 * a01 + b1 * a11 + b22 * a21 + b32 * a31;
  out[2] = b0 * a02 + b1 * a12 + b22 * a22 + b32 * a32;
  out[3] = b0 * a03 + b1 * a13 + b22 * a23 + b32 * a33;
  b0 = b3[4];
  b1 = b3[5];
  b22 = b3[6];
  b32 = b3[7];
  out[4] = b0 * a00 + b1 * a10 + b22 * a20 + b32 * a30;
  out[5] = b0 * a01 + b1 * a11 + b22 * a21 + b32 * a31;
  out[6] = b0 * a02 + b1 * a12 + b22 * a22 + b32 * a32;
  out[7] = b0 * a03 + b1 * a13 + b22 * a23 + b32 * a33;
  b0 = b3[8];
  b1 = b3[9];
  b22 = b3[10];
  b32 = b3[11];
  out[8] = b0 * a00 + b1 * a10 + b22 * a20 + b32 * a30;
  out[9] = b0 * a01 + b1 * a11 + b22 * a21 + b32 * a31;
  out[10] = b0 * a02 + b1 * a12 + b22 * a22 + b32 * a32;
  out[11] = b0 * a03 + b1 * a13 + b22 * a23 + b32 * a33;
  b0 = b3[12];
  b1 = b3[13];
  b22 = b3[14];
  b32 = b3[15];
  out[12] = b0 * a00 + b1 * a10 + b22 * a20 + b32 * a30;
  out[13] = b0 * a01 + b1 * a11 + b22 * a21 + b32 * a31;
  out[14] = b0 * a02 + b1 * a12 + b22 * a22 + b32 * a32;
  out[15] = b0 * a03 + b1 * a13 + b22 * a23 + b32 * a33;
  return out;
}
function translate(out, a3, v2) {
  let x2 = v2[0], y3 = v2[1], z2 = v2[2];
  let a00, a01, a02, a03;
  let a10, a11, a12, a13;
  let a20, a21, a22, a23;
  if (a3 === out) {
    out[12] = a3[0] * x2 + a3[4] * y3 + a3[8] * z2 + a3[12];
    out[13] = a3[1] * x2 + a3[5] * y3 + a3[9] * z2 + a3[13];
    out[14] = a3[2] * x2 + a3[6] * y3 + a3[10] * z2 + a3[14];
    out[15] = a3[3] * x2 + a3[7] * y3 + a3[11] * z2 + a3[15];
  } else {
    a00 = a3[0];
    a01 = a3[1];
    a02 = a3[2];
    a03 = a3[3];
    a10 = a3[4];
    a11 = a3[5];
    a12 = a3[6];
    a13 = a3[7];
    a20 = a3[8];
    a21 = a3[9];
    a22 = a3[10];
    a23 = a3[11];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a03;
    out[4] = a10;
    out[5] = a11;
    out[6] = a12;
    out[7] = a13;
    out[8] = a20;
    out[9] = a21;
    out[10] = a22;
    out[11] = a23;
    out[12] = a00 * x2 + a10 * y3 + a20 * z2 + a3[12];
    out[13] = a01 * x2 + a11 * y3 + a21 * z2 + a3[13];
    out[14] = a02 * x2 + a12 * y3 + a22 * z2 + a3[14];
    out[15] = a03 * x2 + a13 * y3 + a23 * z2 + a3[15];
  }
  return out;
}
function scale3(out, a3, v2) {
  let x2 = v2[0], y3 = v2[1], z2 = v2[2];
  out[0] = a3[0] * x2;
  out[1] = a3[1] * x2;
  out[2] = a3[2] * x2;
  out[3] = a3[3] * x2;
  out[4] = a3[4] * y3;
  out[5] = a3[5] * y3;
  out[6] = a3[6] * y3;
  out[7] = a3[7] * y3;
  out[8] = a3[8] * z2;
  out[9] = a3[9] * z2;
  out[10] = a3[10] * z2;
  out[11] = a3[11] * z2;
  out[12] = a3[12];
  out[13] = a3[13];
  out[14] = a3[14];
  out[15] = a3[15];
  return out;
}
function rotate(out, a3, rad, axis) {
  let x2 = axis[0], y3 = axis[1], z2 = axis[2];
  let len = Math.hypot(x2, y3, z2);
  let s4, c4, t4;
  let a00, a01, a02, a03;
  let a10, a11, a12, a13;
  let a20, a21, a22, a23;
  let b00, b01, b02;
  let b10, b11, b12;
  let b20, b21, b22;
  if (Math.abs(len) < EPSILON) {
    return null;
  }
  len = 1 / len;
  x2 *= len;
  y3 *= len;
  z2 *= len;
  s4 = Math.sin(rad);
  c4 = Math.cos(rad);
  t4 = 1 - c4;
  a00 = a3[0];
  a01 = a3[1];
  a02 = a3[2];
  a03 = a3[3];
  a10 = a3[4];
  a11 = a3[5];
  a12 = a3[6];
  a13 = a3[7];
  a20 = a3[8];
  a21 = a3[9];
  a22 = a3[10];
  a23 = a3[11];
  b00 = x2 * x2 * t4 + c4;
  b01 = y3 * x2 * t4 + z2 * s4;
  b02 = z2 * x2 * t4 - y3 * s4;
  b10 = x2 * y3 * t4 - z2 * s4;
  b11 = y3 * y3 * t4 + c4;
  b12 = z2 * y3 * t4 + x2 * s4;
  b20 = x2 * z2 * t4 + y3 * s4;
  b21 = y3 * z2 * t4 - x2 * s4;
  b22 = z2 * z2 * t4 + c4;
  out[0] = a00 * b00 + a10 * b01 + a20 * b02;
  out[1] = a01 * b00 + a11 * b01 + a21 * b02;
  out[2] = a02 * b00 + a12 * b01 + a22 * b02;
  out[3] = a03 * b00 + a13 * b01 + a23 * b02;
  out[4] = a00 * b10 + a10 * b11 + a20 * b12;
  out[5] = a01 * b10 + a11 * b11 + a21 * b12;
  out[6] = a02 * b10 + a12 * b11 + a22 * b12;
  out[7] = a03 * b10 + a13 * b11 + a23 * b12;
  out[8] = a00 * b20 + a10 * b21 + a20 * b22;
  out[9] = a01 * b20 + a11 * b21 + a21 * b22;
  out[10] = a02 * b20 + a12 * b21 + a22 * b22;
  out[11] = a03 * b20 + a13 * b21 + a23 * b22;
  if (a3 !== out) {
    out[12] = a3[12];
    out[13] = a3[13];
    out[14] = a3[14];
    out[15] = a3[15];
  }
  return out;
}
function getTranslation(out, mat) {
  out[0] = mat[12];
  out[1] = mat[13];
  out[2] = mat[14];
  return out;
}
function getScaling(out, mat) {
  let m11 = mat[0];
  let m12 = mat[1];
  let m13 = mat[2];
  let m21 = mat[4];
  let m22 = mat[5];
  let m23 = mat[6];
  let m31 = mat[8];
  let m32 = mat[9];
  let m33 = mat[10];
  out[0] = Math.hypot(m11, m12, m13);
  out[1] = Math.hypot(m21, m22, m23);
  out[2] = Math.hypot(m31, m32, m33);
  return out;
}
function getMaxScaleOnAxis(mat) {
  let m11 = mat[0];
  let m12 = mat[1];
  let m13 = mat[2];
  let m21 = mat[4];
  let m22 = mat[5];
  let m23 = mat[6];
  let m31 = mat[8];
  let m32 = mat[9];
  let m33 = mat[10];
  const x2 = m11 * m11 + m12 * m12 + m13 * m13;
  const y3 = m21 * m21 + m22 * m22 + m23 * m23;
  const z2 = m31 * m31 + m32 * m32 + m33 * m33;
  return Math.sqrt(Math.max(x2, y3, z2));
}
var getRotation = /* @__PURE__ */ (function() {
  const temp = [1, 1, 1];
  return function(out, mat) {
    let scaling = temp;
    getScaling(scaling, mat);
    let is1 = 1 / scaling[0];
    let is2 = 1 / scaling[1];
    let is3 = 1 / scaling[2];
    let sm11 = mat[0] * is1;
    let sm12 = mat[1] * is2;
    let sm13 = mat[2] * is3;
    let sm21 = mat[4] * is1;
    let sm22 = mat[5] * is2;
    let sm23 = mat[6] * is3;
    let sm31 = mat[8] * is1;
    let sm32 = mat[9] * is2;
    let sm33 = mat[10] * is3;
    let trace = sm11 + sm22 + sm33;
    let S3 = 0;
    if (trace > 0) {
      S3 = Math.sqrt(trace + 1) * 2;
      out[3] = 0.25 * S3;
      out[0] = (sm23 - sm32) / S3;
      out[1] = (sm31 - sm13) / S3;
      out[2] = (sm12 - sm21) / S3;
    } else if (sm11 > sm22 && sm11 > sm33) {
      S3 = Math.sqrt(1 + sm11 - sm22 - sm33) * 2;
      out[3] = (sm23 - sm32) / S3;
      out[0] = 0.25 * S3;
      out[1] = (sm12 + sm21) / S3;
      out[2] = (sm31 + sm13) / S3;
    } else if (sm22 > sm33) {
      S3 = Math.sqrt(1 + sm22 - sm11 - sm33) * 2;
      out[3] = (sm31 - sm13) / S3;
      out[0] = (sm12 + sm21) / S3;
      out[1] = 0.25 * S3;
      out[2] = (sm23 + sm32) / S3;
    } else {
      S3 = Math.sqrt(1 + sm33 - sm11 - sm22) * 2;
      out[3] = (sm12 - sm21) / S3;
      out[0] = (sm31 + sm13) / S3;
      out[1] = (sm23 + sm32) / S3;
      out[2] = 0.25 * S3;
    }
    return out;
  };
})();
function decompose(srcMat, dstRotation, dstTranslation, dstScale) {
  let sx = length([srcMat[0], srcMat[1], srcMat[2]]);
  const sy = length([srcMat[4], srcMat[5], srcMat[6]]);
  const sz = length([srcMat[8], srcMat[9], srcMat[10]]);
  const det = determinant(srcMat);
  if (det < 0) sx = -sx;
  dstTranslation[0] = srcMat[12];
  dstTranslation[1] = srcMat[13];
  dstTranslation[2] = srcMat[14];
  const _m1 = srcMat.slice();
  const invSX = 1 / sx;
  const invSY = 1 / sy;
  const invSZ = 1 / sz;
  _m1[0] *= invSX;
  _m1[1] *= invSX;
  _m1[2] *= invSX;
  _m1[4] *= invSY;
  _m1[5] *= invSY;
  _m1[6] *= invSY;
  _m1[8] *= invSZ;
  _m1[9] *= invSZ;
  _m1[10] *= invSZ;
  getRotation(dstRotation, _m1);
  dstScale[0] = sx;
  dstScale[1] = sy;
  dstScale[2] = sz;
}
function compose(dstMat, srcRotation, srcTranslation, srcScale) {
  const te = dstMat;
  const x2 = srcRotation[0], y3 = srcRotation[1], z2 = srcRotation[2], w2 = srcRotation[3];
  const x22 = x2 + x2, y22 = y3 + y3, z22 = z2 + z2;
  const xx = x2 * x22, xy = x2 * y22, xz = x2 * z22;
  const yy = y3 * y22, yz = y3 * z22, zz = z2 * z22;
  const wx = w2 * x22, wy = w2 * y22, wz = w2 * z22;
  const sx = srcScale[0], sy = srcScale[1], sz = srcScale[2];
  te[0] = (1 - (yy + zz)) * sx;
  te[1] = (xy + wz) * sx;
  te[2] = (xz - wy) * sx;
  te[3] = 0;
  te[4] = (xy - wz) * sy;
  te[5] = (1 - (xx + zz)) * sy;
  te[6] = (yz + wx) * sy;
  te[7] = 0;
  te[8] = (xz + wy) * sz;
  te[9] = (yz - wx) * sz;
  te[10] = (1 - (xx + yy)) * sz;
  te[11] = 0;
  te[12] = srcTranslation[0];
  te[13] = srcTranslation[1];
  te[14] = srcTranslation[2];
  te[15] = 1;
  return te;
}
function fromQuat(out, q) {
  let x2 = q[0], y3 = q[1], z2 = q[2], w2 = q[3];
  let x22 = x2 + x2;
  let y22 = y3 + y3;
  let z22 = z2 + z2;
  let xx = x2 * x22;
  let yx = y3 * x22;
  let yy = y3 * y22;
  let zx = z2 * x22;
  let zy = z2 * y22;
  let zz = z2 * z22;
  let wx = w2 * x22;
  let wy = w2 * y22;
  let wz = w2 * z22;
  out[0] = 1 - yy - zz;
  out[1] = yx + wz;
  out[2] = zx - wy;
  out[3] = 0;
  out[4] = yx - wz;
  out[5] = 1 - xx - zz;
  out[6] = zy + wx;
  out[7] = 0;
  out[8] = zx + wy;
  out[9] = zy - wx;
  out[10] = 1 - xx - yy;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
function perspective(out, fovy, aspect, near, far) {
  let f3 = 1 / Math.tan(fovy / 2);
  let nf = 1 / (near - far);
  out[0] = f3 / aspect;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = f3;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = (far + near) * nf;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[14] = 2 * far * near * nf;
  out[15] = 0;
  return out;
}
function ortho(out, left, right, bottom, top, near, far) {
  let lr = 1 / (left - right);
  let bt = 1 / (bottom - top);
  let nf = 1 / (near - far);
  out[0] = -2 * lr;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = -2 * bt;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 2 * nf;
  out[11] = 0;
  out[12] = (left + right) * lr;
  out[13] = (top + bottom) * bt;
  out[14] = (far + near) * nf;
  out[15] = 1;
  return out;
}
function targetTo(out, eye, target, up) {
  let eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
  let z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
  let len = z0 * z0 + z1 * z1 + z2 * z2;
  if (len === 0) {
    z2 = 1;
  } else {
    len = 1 / Math.sqrt(len);
    z0 *= len;
    z1 *= len;
    z2 *= len;
  }
  let x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
  len = x0 * x0 + x1 * x1 + x2 * x2;
  if (len === 0) {
    if (upz) {
      upx += 1e-6;
    } else if (upy) {
      upz += 1e-6;
    } else {
      upy += 1e-6;
    }
    x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
  }
  len = 1 / Math.sqrt(len);
  x0 *= len;
  x1 *= len;
  x2 *= len;
  out[0] = x0;
  out[1] = x1;
  out[2] = x2;
  out[3] = 0;
  out[4] = z1 * x2 - z2 * x1;
  out[5] = z2 * x0 - z0 * x2;
  out[6] = z0 * x1 - z1 * x0;
  out[7] = 0;
  out[8] = z0;
  out[9] = z1;
  out[10] = z2;
  out[11] = 0;
  out[12] = eyex;
  out[13] = eyey;
  out[14] = eyez;
  out[15] = 1;
  return out;
}
function add3(out, a3, b3) {
  out[0] = a3[0] + b3[0];
  out[1] = a3[1] + b3[1];
  out[2] = a3[2] + b3[2];
  out[3] = a3[3] + b3[3];
  out[4] = a3[4] + b3[4];
  out[5] = a3[5] + b3[5];
  out[6] = a3[6] + b3[6];
  out[7] = a3[7] + b3[7];
  out[8] = a3[8] + b3[8];
  out[9] = a3[9] + b3[9];
  out[10] = a3[10] + b3[10];
  out[11] = a3[11] + b3[11];
  out[12] = a3[12] + b3[12];
  out[13] = a3[13] + b3[13];
  out[14] = a3[14] + b3[14];
  out[15] = a3[15] + b3[15];
  return out;
}
function subtract2(out, a3, b3) {
  out[0] = a3[0] - b3[0];
  out[1] = a3[1] - b3[1];
  out[2] = a3[2] - b3[2];
  out[3] = a3[3] - b3[3];
  out[4] = a3[4] - b3[4];
  out[5] = a3[5] - b3[5];
  out[6] = a3[6] - b3[6];
  out[7] = a3[7] - b3[7];
  out[8] = a3[8] - b3[8];
  out[9] = a3[9] - b3[9];
  out[10] = a3[10] - b3[10];
  out[11] = a3[11] - b3[11];
  out[12] = a3[12] - b3[12];
  out[13] = a3[13] - b3[13];
  out[14] = a3[14] - b3[14];
  out[15] = a3[15] - b3[15];
  return out;
}
function multiplyScalar(out, a3, b3) {
  out[0] = a3[0] * b3;
  out[1] = a3[1] * b3;
  out[2] = a3[2] * b3;
  out[3] = a3[3] * b3;
  out[4] = a3[4] * b3;
  out[5] = a3[5] * b3;
  out[6] = a3[6] * b3;
  out[7] = a3[7] * b3;
  out[8] = a3[8] * b3;
  out[9] = a3[9] * b3;
  out[10] = a3[10] * b3;
  out[11] = a3[11] * b3;
  out[12] = a3[12] * b3;
  out[13] = a3[13] * b3;
  out[14] = a3[14] * b3;
  out[15] = a3[15] * b3;
  return out;
}

// node_modules/ogl/src/math/Mat4.js
var Mat4 = class extends Array {
  constructor(m00 = 1, m01 = 0, m02 = 0, m03 = 0, m10 = 0, m11 = 1, m12 = 0, m13 = 0, m20 = 0, m21 = 0, m22 = 1, m23 = 0, m30 = 0, m31 = 0, m32 = 0, m33 = 1) {
    super(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33);
    return this;
  }
  get x() {
    return this[12];
  }
  get y() {
    return this[13];
  }
  get z() {
    return this[14];
  }
  get w() {
    return this[15];
  }
  set x(v2) {
    this[12] = v2;
  }
  set y(v2) {
    this[13] = v2;
  }
  set z(v2) {
    this[14] = v2;
  }
  set w(v2) {
    this[15] = v2;
  }
  set(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    if (m00.length) return this.copy(m00);
    set4(this, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33);
    return this;
  }
  translate(v2, m2 = this) {
    translate(this, m2, v2);
    return this;
  }
  rotate(v2, axis, m2 = this) {
    rotate(this, m2, v2, axis);
    return this;
  }
  scale(v2, m2 = this) {
    scale3(this, m2, typeof v2 === "number" ? [v2, v2, v2] : v2);
    return this;
  }
  add(ma, mb) {
    if (mb) add3(this, ma, mb);
    else add3(this, this, ma);
    return this;
  }
  sub(ma, mb) {
    if (mb) subtract2(this, ma, mb);
    else subtract2(this, this, ma);
    return this;
  }
  multiply(ma, mb) {
    if (!ma.length) {
      multiplyScalar(this, this, ma);
    } else if (mb) {
      multiply3(this, ma, mb);
    } else {
      multiply3(this, this, ma);
    }
    return this;
  }
  identity() {
    identity2(this);
    return this;
  }
  copy(m2) {
    copy4(this, m2);
    return this;
  }
  fromPerspective({ fov, aspect, near, far } = {}) {
    perspective(this, fov, aspect, near, far);
    return this;
  }
  fromOrthogonal({ left, right, bottom, top, near, far }) {
    ortho(this, left, right, bottom, top, near, far);
    return this;
  }
  fromQuaternion(q) {
    fromQuat(this, q);
    return this;
  }
  setPosition(v2) {
    this.x = v2[0];
    this.y = v2[1];
    this.z = v2[2];
    return this;
  }
  inverse(m2 = this) {
    invert2(this, m2);
    return this;
  }
  compose(q, pos, scale5) {
    compose(this, q, pos, scale5);
    return this;
  }
  decompose(q, pos, scale5) {
    decompose(this, q, pos, scale5);
    return this;
  }
  getRotation(q) {
    getRotation(q, this);
    return this;
  }
  getTranslation(pos) {
    getTranslation(pos, this);
    return this;
  }
  getScaling(scale5) {
    getScaling(scale5, this);
    return this;
  }
  getMaxScaleOnAxis() {
    return getMaxScaleOnAxis(this);
  }
  lookAt(eye, target, up) {
    targetTo(this, eye, target, up);
    return this;
  }
  determinant() {
    return determinant(this);
  }
  fromArray(a3, o6 = 0) {
    this[0] = a3[o6];
    this[1] = a3[o6 + 1];
    this[2] = a3[o6 + 2];
    this[3] = a3[o6 + 3];
    this[4] = a3[o6 + 4];
    this[5] = a3[o6 + 5];
    this[6] = a3[o6 + 6];
    this[7] = a3[o6 + 7];
    this[8] = a3[o6 + 8];
    this[9] = a3[o6 + 9];
    this[10] = a3[o6 + 10];
    this[11] = a3[o6 + 11];
    this[12] = a3[o6 + 12];
    this[13] = a3[o6 + 13];
    this[14] = a3[o6 + 14];
    this[15] = a3[o6 + 15];
    return this;
  }
  toArray(a3 = [], o6 = 0) {
    a3[o6] = this[0];
    a3[o6 + 1] = this[1];
    a3[o6 + 2] = this[2];
    a3[o6 + 3] = this[3];
    a3[o6 + 4] = this[4];
    a3[o6 + 5] = this[5];
    a3[o6 + 6] = this[6];
    a3[o6 + 7] = this[7];
    a3[o6 + 8] = this[8];
    a3[o6 + 9] = this[9];
    a3[o6 + 10] = this[10];
    a3[o6 + 11] = this[11];
    a3[o6 + 12] = this[12];
    a3[o6 + 13] = this[13];
    a3[o6 + 14] = this[14];
    a3[o6 + 15] = this[15];
    return a3;
  }
};

// node_modules/ogl/src/math/functions/EulerFunc.js
function fromRotationMatrix(out, m2, order = "YXZ") {
  if (order === "XYZ") {
    out[1] = Math.asin(Math.min(Math.max(m2[8], -1), 1));
    if (Math.abs(m2[8]) < 0.99999) {
      out[0] = Math.atan2(-m2[9], m2[10]);
      out[2] = Math.atan2(-m2[4], m2[0]);
    } else {
      out[0] = Math.atan2(m2[6], m2[5]);
      out[2] = 0;
    }
  } else if (order === "YXZ") {
    out[0] = Math.asin(-Math.min(Math.max(m2[9], -1), 1));
    if (Math.abs(m2[9]) < 0.99999) {
      out[1] = Math.atan2(m2[8], m2[10]);
      out[2] = Math.atan2(m2[1], m2[5]);
    } else {
      out[1] = Math.atan2(-m2[2], m2[0]);
      out[2] = 0;
    }
  } else if (order === "ZXY") {
    out[0] = Math.asin(Math.min(Math.max(m2[6], -1), 1));
    if (Math.abs(m2[6]) < 0.99999) {
      out[1] = Math.atan2(-m2[2], m2[10]);
      out[2] = Math.atan2(-m2[4], m2[5]);
    } else {
      out[1] = 0;
      out[2] = Math.atan2(m2[1], m2[0]);
    }
  } else if (order === "ZYX") {
    out[1] = Math.asin(-Math.min(Math.max(m2[2], -1), 1));
    if (Math.abs(m2[2]) < 0.99999) {
      out[0] = Math.atan2(m2[6], m2[10]);
      out[2] = Math.atan2(m2[1], m2[0]);
    } else {
      out[0] = 0;
      out[2] = Math.atan2(-m2[4], m2[5]);
    }
  } else if (order === "YZX") {
    out[2] = Math.asin(Math.min(Math.max(m2[1], -1), 1));
    if (Math.abs(m2[1]) < 0.99999) {
      out[0] = Math.atan2(-m2[9], m2[5]);
      out[1] = Math.atan2(-m2[2], m2[0]);
    } else {
      out[0] = 0;
      out[1] = Math.atan2(m2[8], m2[10]);
    }
  } else if (order === "XZY") {
    out[2] = Math.asin(-Math.min(Math.max(m2[4], -1), 1));
    if (Math.abs(m2[4]) < 0.99999) {
      out[0] = Math.atan2(m2[6], m2[5]);
      out[1] = Math.atan2(m2[8], m2[0]);
    } else {
      out[0] = Math.atan2(-m2[9], m2[10]);
      out[1] = 0;
    }
  }
  return out;
}

// node_modules/ogl/src/math/Euler.js
var tmpMat4 = /* @__PURE__ */ new Mat4();
var Euler = class extends Array {
  constructor(x2 = 0, y3 = x2, z2 = x2, order = "YXZ") {
    super(x2, y3, z2);
    this.order = order;
    this.onChange = () => {
    };
    this._target = this;
    const triggerProps = ["0", "1", "2"];
    return new Proxy(this, {
      set(target, property) {
        const success = Reflect.set(...arguments);
        if (success && triggerProps.includes(property)) target.onChange();
        return success;
      }
    });
  }
  get x() {
    return this[0];
  }
  get y() {
    return this[1];
  }
  get z() {
    return this[2];
  }
  set x(v2) {
    this._target[0] = v2;
    this.onChange();
  }
  set y(v2) {
    this._target[1] = v2;
    this.onChange();
  }
  set z(v2) {
    this._target[2] = v2;
    this.onChange();
  }
  set(x2, y3 = x2, z2 = x2) {
    if (x2.length) return this.copy(x2);
    this._target[0] = x2;
    this._target[1] = y3;
    this._target[2] = z2;
    this.onChange();
    return this;
  }
  copy(v2) {
    this._target[0] = v2[0];
    this._target[1] = v2[1];
    this._target[2] = v2[2];
    this.onChange();
    return this;
  }
  reorder(order) {
    this._target.order = order;
    this.onChange();
    return this;
  }
  fromRotationMatrix(m2, order = this.order) {
    fromRotationMatrix(this._target, m2, order);
    this.onChange();
    return this;
  }
  fromQuaternion(q, order = this.order, isInternal) {
    tmpMat4.fromQuaternion(q);
    this._target.fromRotationMatrix(tmpMat4, order);
    if (!isInternal) this.onChange();
    return this;
  }
  fromArray(a3, o6 = 0) {
    this._target[0] = a3[o6];
    this._target[1] = a3[o6 + 1];
    this._target[2] = a3[o6 + 2];
    return this;
  }
  toArray(a3 = [], o6 = 0) {
    a3[o6] = this[0];
    a3[o6 + 1] = this[1];
    a3[o6 + 2] = this[2];
    return a3;
  }
};

// node_modules/ogl/src/core/Transform.js
var Transform = class {
  constructor() {
    this.parent = null;
    this.children = [];
    this.visible = true;
    this.matrix = new Mat4();
    this.worldMatrix = new Mat4();
    this.matrixAutoUpdate = true;
    this.worldMatrixNeedsUpdate = false;
    this.position = new Vec3();
    this.quaternion = new Quat();
    this.scale = new Vec3(1);
    this.rotation = new Euler();
    this.up = new Vec3(0, 1, 0);
    this.rotation._target.onChange = () => this.quaternion.fromEuler(this.rotation, true);
    this.quaternion._target.onChange = () => this.rotation.fromQuaternion(this.quaternion, void 0, true);
  }
  setParent(parent, notifyParent = true) {
    if (this.parent && parent !== this.parent) this.parent.removeChild(this, false);
    this.parent = parent;
    if (notifyParent && parent) parent.addChild(this, false);
  }
  addChild(child, notifyChild = true) {
    if (!~this.children.indexOf(child)) this.children.push(child);
    if (notifyChild) child.setParent(this, false);
  }
  removeChild(child, notifyChild = true) {
    if (!!~this.children.indexOf(child)) this.children.splice(this.children.indexOf(child), 1);
    if (notifyChild) child.setParent(null, false);
  }
  updateMatrixWorld(force) {
    if (this.matrixAutoUpdate) this.updateMatrix();
    if (this.worldMatrixNeedsUpdate || force) {
      if (this.parent === null) this.worldMatrix.copy(this.matrix);
      else this.worldMatrix.multiply(this.parent.worldMatrix, this.matrix);
      this.worldMatrixNeedsUpdate = false;
      force = true;
    }
    for (let i5 = 0, l3 = this.children.length; i5 < l3; i5++) {
      this.children[i5].updateMatrixWorld(force);
    }
  }
  updateMatrix() {
    this.matrix.compose(this.quaternion, this.position, this.scale);
    this.worldMatrixNeedsUpdate = true;
  }
  traverse(callback) {
    if (callback(this)) return;
    for (let i5 = 0, l3 = this.children.length; i5 < l3; i5++) {
      this.children[i5].traverse(callback);
    }
  }
  decompose() {
    this.matrix.decompose(this.quaternion._target, this.position, this.scale);
    this.rotation.fromQuaternion(this.quaternion);
  }
  lookAt(target, invert4 = false) {
    if (invert4) this.matrix.lookAt(this.position, target, this.up);
    else this.matrix.lookAt(target, this.position, this.up);
    this.matrix.getRotation(this.quaternion._target);
    this.rotation.fromQuaternion(this.quaternion);
  }
};

// node_modules/ogl/src/core/Camera.js
var tempMat4 = /* @__PURE__ */ new Mat4();
var tempVec3a = /* @__PURE__ */ new Vec3();
var tempVec3b = /* @__PURE__ */ new Vec3();
var Camera = class extends Transform {
  constructor(gl, { near = 0.1, far = 100, fov = 45, aspect = 1, left, right, bottom, top, zoom = 1 } = {}) {
    super();
    Object.assign(this, { near, far, fov, aspect, left, right, bottom, top, zoom });
    this.projectionMatrix = new Mat4();
    this.viewMatrix = new Mat4();
    this.projectionViewMatrix = new Mat4();
    this.worldPosition = new Vec3();
    this.type = left || right ? "orthographic" : "perspective";
    if (this.type === "orthographic") this.orthographic();
    else this.perspective();
  }
  perspective({ near = this.near, far = this.far, fov = this.fov, aspect = this.aspect } = {}) {
    Object.assign(this, { near, far, fov, aspect });
    this.projectionMatrix.fromPerspective({ fov: fov * (Math.PI / 180), aspect, near, far });
    this.type = "perspective";
    return this;
  }
  orthographic({
    near = this.near,
    far = this.far,
    left = this.left || -1,
    right = this.right || 1,
    bottom = this.bottom || -1,
    top = this.top || 1,
    zoom = this.zoom
  } = {}) {
    Object.assign(this, { near, far, left, right, bottom, top, zoom });
    left /= zoom;
    right /= zoom;
    bottom /= zoom;
    top /= zoom;
    this.projectionMatrix.fromOrthogonal({ left, right, bottom, top, near, far });
    this.type = "orthographic";
    return this;
  }
  updateMatrixWorld() {
    super.updateMatrixWorld();
    this.viewMatrix.inverse(this.worldMatrix);
    this.worldMatrix.getTranslation(this.worldPosition);
    this.projectionViewMatrix.multiply(this.projectionMatrix, this.viewMatrix);
    return this;
  }
  updateProjectionMatrix() {
    if (this.type === "perspective") {
      return this.perspective();
    } else {
      return this.orthographic();
    }
  }
  lookAt(target) {
    super.lookAt(target, true);
    return this;
  }
  // Project 3D coordinate to 2D point
  project(v2) {
    v2.applyMatrix4(this.viewMatrix);
    v2.applyMatrix4(this.projectionMatrix);
    return this;
  }
  // Unproject 2D point to 3D coordinate
  unproject(v2) {
    v2.applyMatrix4(tempMat4.inverse(this.projectionMatrix));
    v2.applyMatrix4(this.worldMatrix);
    return this;
  }
  updateFrustum() {
    if (!this.frustum) {
      this.frustum = [new Vec3(), new Vec3(), new Vec3(), new Vec3(), new Vec3(), new Vec3()];
    }
    const m2 = this.projectionViewMatrix;
    this.frustum[0].set(m2[3] - m2[0], m2[7] - m2[4], m2[11] - m2[8]).constant = m2[15] - m2[12];
    this.frustum[1].set(m2[3] + m2[0], m2[7] + m2[4], m2[11] + m2[8]).constant = m2[15] + m2[12];
    this.frustum[2].set(m2[3] + m2[1], m2[7] + m2[5], m2[11] + m2[9]).constant = m2[15] + m2[13];
    this.frustum[3].set(m2[3] - m2[1], m2[7] - m2[5], m2[11] - m2[9]).constant = m2[15] - m2[13];
    this.frustum[4].set(m2[3] - m2[2], m2[7] - m2[6], m2[11] - m2[10]).constant = m2[15] - m2[14];
    this.frustum[5].set(m2[3] + m2[2], m2[7] + m2[6], m2[11] + m2[10]).constant = m2[15] + m2[14];
    for (let i5 = 0; i5 < 6; i5++) {
      const invLen = 1 / this.frustum[i5].distance();
      this.frustum[i5].multiply(invLen);
      this.frustum[i5].constant *= invLen;
    }
  }
  frustumIntersectsMesh(node, worldMatrix = node.worldMatrix) {
    if (!node.geometry.attributes.position) return true;
    if (!node.geometry.bounds || node.geometry.bounds.radius === Infinity) node.geometry.computeBoundingSphere();
    if (!node.geometry.bounds) return true;
    const center = tempVec3a;
    center.copy(node.geometry.bounds.center);
    center.applyMatrix4(worldMatrix);
    const radius = node.geometry.bounds.radius * worldMatrix.getMaxScaleOnAxis();
    return this.frustumIntersectsSphere(center, radius);
  }
  frustumIntersectsSphere(center, radius) {
    const normal = tempVec3b;
    for (let i5 = 0; i5 < 6; i5++) {
      const plane = this.frustum[i5];
      const distance2 = normal.copy(plane).dot(center) + plane.constant;
      if (distance2 < -radius) return false;
    }
    return true;
  }
};

// node_modules/ogl/src/math/functions/Mat3Func.js
function fromMat4(out, a3) {
  out[0] = a3[0];
  out[1] = a3[1];
  out[2] = a3[2];
  out[3] = a3[4];
  out[4] = a3[5];
  out[5] = a3[6];
  out[6] = a3[8];
  out[7] = a3[9];
  out[8] = a3[10];
  return out;
}
function fromQuat2(out, q) {
  let x2 = q[0], y3 = q[1], z2 = q[2], w2 = q[3];
  let x22 = x2 + x2;
  let y22 = y3 + y3;
  let z22 = z2 + z2;
  let xx = x2 * x22;
  let yx = y3 * x22;
  let yy = y3 * y22;
  let zx = z2 * x22;
  let zy = z2 * y22;
  let zz = z2 * z22;
  let wx = w2 * x22;
  let wy = w2 * y22;
  let wz = w2 * z22;
  out[0] = 1 - yy - zz;
  out[3] = yx - wz;
  out[6] = zx + wy;
  out[1] = yx + wz;
  out[4] = 1 - xx - zz;
  out[7] = zy - wx;
  out[2] = zx - wy;
  out[5] = zy + wx;
  out[8] = 1 - xx - yy;
  return out;
}
function copy5(out, a3) {
  out[0] = a3[0];
  out[1] = a3[1];
  out[2] = a3[2];
  out[3] = a3[3];
  out[4] = a3[4];
  out[5] = a3[5];
  out[6] = a3[6];
  out[7] = a3[7];
  out[8] = a3[8];
  return out;
}
function set5(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m10;
  out[4] = m11;
  out[5] = m12;
  out[6] = m20;
  out[7] = m21;
  out[8] = m22;
  return out;
}
function identity3(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 1;
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}
function invert3(out, a3) {
  let a00 = a3[0], a01 = a3[1], a02 = a3[2];
  let a10 = a3[3], a11 = a3[4], a12 = a3[5];
  let a20 = a3[6], a21 = a3[7], a22 = a3[8];
  let b01 = a22 * a11 - a12 * a21;
  let b11 = -a22 * a10 + a12 * a20;
  let b21 = a21 * a10 - a11 * a20;
  let det = a00 * b01 + a01 * b11 + a02 * b21;
  if (!det) {
    return null;
  }
  det = 1 / det;
  out[0] = b01 * det;
  out[1] = (-a22 * a01 + a02 * a21) * det;
  out[2] = (a12 * a01 - a02 * a11) * det;
  out[3] = b11 * det;
  out[4] = (a22 * a00 - a02 * a20) * det;
  out[5] = (-a12 * a00 + a02 * a10) * det;
  out[6] = b21 * det;
  out[7] = (-a21 * a00 + a01 * a20) * det;
  out[8] = (a11 * a00 - a01 * a10) * det;
  return out;
}
function multiply4(out, a3, b3) {
  let a00 = a3[0], a01 = a3[1], a02 = a3[2];
  let a10 = a3[3], a11 = a3[4], a12 = a3[5];
  let a20 = a3[6], a21 = a3[7], a22 = a3[8];
  let b00 = b3[0], b01 = b3[1], b02 = b3[2];
  let b10 = b3[3], b11 = b3[4], b12 = b3[5];
  let b20 = b3[6], b21 = b3[7], b22 = b3[8];
  out[0] = b00 * a00 + b01 * a10 + b02 * a20;
  out[1] = b00 * a01 + b01 * a11 + b02 * a21;
  out[2] = b00 * a02 + b01 * a12 + b02 * a22;
  out[3] = b10 * a00 + b11 * a10 + b12 * a20;
  out[4] = b10 * a01 + b11 * a11 + b12 * a21;
  out[5] = b10 * a02 + b11 * a12 + b12 * a22;
  out[6] = b20 * a00 + b21 * a10 + b22 * a20;
  out[7] = b20 * a01 + b21 * a11 + b22 * a21;
  out[8] = b20 * a02 + b21 * a12 + b22 * a22;
  return out;
}
function translate2(out, a3, v2) {
  let a00 = a3[0], a01 = a3[1], a02 = a3[2], a10 = a3[3], a11 = a3[4], a12 = a3[5], a20 = a3[6], a21 = a3[7], a22 = a3[8], x2 = v2[0], y3 = v2[1];
  out[0] = a00;
  out[1] = a01;
  out[2] = a02;
  out[3] = a10;
  out[4] = a11;
  out[5] = a12;
  out[6] = x2 * a00 + y3 * a10 + a20;
  out[7] = x2 * a01 + y3 * a11 + a21;
  out[8] = x2 * a02 + y3 * a12 + a22;
  return out;
}
function rotate2(out, a3, rad) {
  let a00 = a3[0], a01 = a3[1], a02 = a3[2], a10 = a3[3], a11 = a3[4], a12 = a3[5], a20 = a3[6], a21 = a3[7], a22 = a3[8], s4 = Math.sin(rad), c4 = Math.cos(rad);
  out[0] = c4 * a00 + s4 * a10;
  out[1] = c4 * a01 + s4 * a11;
  out[2] = c4 * a02 + s4 * a12;
  out[3] = c4 * a10 - s4 * a00;
  out[4] = c4 * a11 - s4 * a01;
  out[5] = c4 * a12 - s4 * a02;
  out[6] = a20;
  out[7] = a21;
  out[8] = a22;
  return out;
}
function scale4(out, a3, v2) {
  let x2 = v2[0], y3 = v2[1];
  out[0] = x2 * a3[0];
  out[1] = x2 * a3[1];
  out[2] = x2 * a3[2];
  out[3] = y3 * a3[3];
  out[4] = y3 * a3[4];
  out[5] = y3 * a3[5];
  out[6] = a3[6];
  out[7] = a3[7];
  out[8] = a3[8];
  return out;
}
function normalFromMat4(out, a3) {
  let a00 = a3[0], a01 = a3[1], a02 = a3[2], a03 = a3[3];
  let a10 = a3[4], a11 = a3[5], a12 = a3[6], a13 = a3[7];
  let a20 = a3[8], a21 = a3[9], a22 = a3[10], a23 = a3[11];
  let a30 = a3[12], a31 = a3[13], a32 = a3[14], a33 = a3[15];
  let b00 = a00 * a11 - a01 * a10;
  let b01 = a00 * a12 - a02 * a10;
  let b02 = a00 * a13 - a03 * a10;
  let b03 = a01 * a12 - a02 * a11;
  let b04 = a01 * a13 - a03 * a11;
  let b05 = a02 * a13 - a03 * a12;
  let b06 = a20 * a31 - a21 * a30;
  let b07 = a20 * a32 - a22 * a30;
  let b08 = a20 * a33 - a23 * a30;
  let b09 = a21 * a32 - a22 * a31;
  let b10 = a21 * a33 - a23 * a31;
  let b11 = a22 * a33 - a23 * a32;
  let det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
  if (!det) {
    return null;
  }
  det = 1 / det;
  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
  out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
  out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
  return out;
}

// node_modules/ogl/src/math/Mat3.js
var Mat3 = class extends Array {
  constructor(m00 = 1, m01 = 0, m02 = 0, m10 = 0, m11 = 1, m12 = 0, m20 = 0, m21 = 0, m22 = 1) {
    super(m00, m01, m02, m10, m11, m12, m20, m21, m22);
    return this;
  }
  set(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    if (m00.length) return this.copy(m00);
    set5(this, m00, m01, m02, m10, m11, m12, m20, m21, m22);
    return this;
  }
  translate(v2, m2 = this) {
    translate2(this, m2, v2);
    return this;
  }
  rotate(v2, m2 = this) {
    rotate2(this, m2, v2);
    return this;
  }
  scale(v2, m2 = this) {
    scale4(this, m2, v2);
    return this;
  }
  multiply(ma, mb) {
    if (mb) {
      multiply4(this, ma, mb);
    } else {
      multiply4(this, this, ma);
    }
    return this;
  }
  identity() {
    identity3(this);
    return this;
  }
  copy(m2) {
    copy5(this, m2);
    return this;
  }
  fromMatrix4(m2) {
    fromMat4(this, m2);
    return this;
  }
  fromQuaternion(q) {
    fromQuat2(this, q);
    return this;
  }
  fromBasis(vec3a, vec3b, vec3c) {
    this.set(vec3a[0], vec3a[1], vec3a[2], vec3b[0], vec3b[1], vec3b[2], vec3c[0], vec3c[1], vec3c[2]);
    return this;
  }
  inverse(m2 = this) {
    invert3(this, m2);
    return this;
  }
  getNormalMatrix(m2) {
    normalFromMat4(this, m2);
    return this;
  }
};

// node_modules/ogl/src/core/Mesh.js
var ID4 = 0;
var Mesh = class extends Transform {
  constructor(gl, { geometry, program, mode = gl.TRIANGLES, frustumCulled = true, renderOrder = 0 } = {}) {
    super();
    if (!gl.canvas) console.error("gl not passed as first argument to Mesh");
    this.gl = gl;
    this.id = ID4++;
    this.geometry = geometry;
    this.program = program;
    this.mode = mode;
    this.frustumCulled = frustumCulled;
    this.renderOrder = renderOrder;
    this.modelViewMatrix = new Mat4();
    this.normalMatrix = new Mat3();
    this.beforeRenderCallbacks = [];
    this.afterRenderCallbacks = [];
  }
  onBeforeRender(f3) {
    this.beforeRenderCallbacks.push(f3);
    return this;
  }
  onAfterRender(f3) {
    this.afterRenderCallbacks.push(f3);
    return this;
  }
  draw({ camera } = {}) {
    if (camera) {
      if (!this.program.uniforms.modelMatrix) {
        Object.assign(this.program.uniforms, {
          modelMatrix: { value: null },
          viewMatrix: { value: null },
          modelViewMatrix: { value: null },
          normalMatrix: { value: null },
          projectionMatrix: { value: null },
          cameraPosition: { value: null }
        });
      }
      this.program.uniforms.projectionMatrix.value = camera.projectionMatrix;
      this.program.uniforms.cameraPosition.value = camera.worldPosition;
      this.program.uniforms.viewMatrix.value = camera.viewMatrix;
      this.modelViewMatrix.multiply(camera.viewMatrix, this.worldMatrix);
      this.normalMatrix.getNormalMatrix(this.modelViewMatrix);
      this.program.uniforms.modelMatrix.value = this.worldMatrix;
      this.program.uniforms.modelViewMatrix.value = this.modelViewMatrix;
      this.program.uniforms.normalMatrix.value = this.normalMatrix;
    }
    this.beforeRenderCallbacks.forEach((f3) => f3 && f3({ mesh: this, camera }));
    let flipFaces = this.program.cullFace && this.worldMatrix.determinant() < 0;
    this.program.use({ flipFaces });
    this.geometry.draw({ mode: this.mode, program: this.program });
    this.afterRenderCallbacks.forEach((f3) => f3 && f3({ mesh: this, camera }));
  }
};

// node_modules/ogl/src/core/Texture.js
var emptyPixel = new Uint8Array(4);
function isPowerOf2(value) {
  return (value & value - 1) === 0;
}
var ID5 = 1;
var Texture = class {
  constructor(gl, {
    image,
    target = gl.TEXTURE_2D,
    type = gl.UNSIGNED_BYTE,
    format = gl.RGBA,
    internalFormat = format,
    wrapS = gl.CLAMP_TO_EDGE,
    wrapT = gl.CLAMP_TO_EDGE,
    wrapR = gl.CLAMP_TO_EDGE,
    generateMipmaps = target === (gl.TEXTURE_2D || gl.TEXTURE_CUBE_MAP),
    minFilter = generateMipmaps ? gl.NEAREST_MIPMAP_LINEAR : gl.LINEAR,
    magFilter = gl.LINEAR,
    premultiplyAlpha = false,
    unpackAlignment = 4,
    flipY = target == (gl.TEXTURE_2D || gl.TEXTURE_3D) ? true : false,
    anisotropy = 0,
    level = 0,
    width,
    // used for RenderTargets or Data Textures
    height = width,
    length: length3 = 1
  } = {}) {
    this.gl = gl;
    this.id = ID5++;
    this.image = image;
    this.target = target;
    this.type = type;
    this.format = format;
    this.internalFormat = internalFormat;
    this.minFilter = minFilter;
    this.magFilter = magFilter;
    this.wrapS = wrapS;
    this.wrapT = wrapT;
    this.wrapR = wrapR;
    this.generateMipmaps = generateMipmaps;
    this.premultiplyAlpha = premultiplyAlpha;
    this.unpackAlignment = unpackAlignment;
    this.flipY = flipY;
    this.anisotropy = Math.min(anisotropy, this.gl.renderer.parameters.maxAnisotropy);
    this.level = level;
    this.width = width;
    this.height = height;
    this.length = length3;
    this.texture = this.gl.createTexture();
    this.store = {
      image: null
    };
    this.glState = this.gl.renderer.state;
    this.state = {};
    this.state.minFilter = this.gl.NEAREST_MIPMAP_LINEAR;
    this.state.magFilter = this.gl.LINEAR;
    this.state.wrapS = this.gl.REPEAT;
    this.state.wrapT = this.gl.REPEAT;
    this.state.anisotropy = 0;
  }
  bind() {
    if (this.glState.textureUnits[this.glState.activeTextureUnit] === this.id) return;
    this.gl.bindTexture(this.target, this.texture);
    this.glState.textureUnits[this.glState.activeTextureUnit] = this.id;
  }
  update(textureUnit = 0) {
    const needsUpdate = !(this.image === this.store.image && !this.needsUpdate);
    if (needsUpdate || this.glState.textureUnits[textureUnit] !== this.id) {
      this.gl.renderer.activeTexture(textureUnit);
      this.bind();
    }
    if (!needsUpdate) return;
    this.needsUpdate = false;
    if (this.flipY !== this.glState.flipY) {
      this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, this.flipY);
      this.glState.flipY = this.flipY;
    }
    if (this.premultiplyAlpha !== this.glState.premultiplyAlpha) {
      this.gl.pixelStorei(this.gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);
      this.glState.premultiplyAlpha = this.premultiplyAlpha;
    }
    if (this.unpackAlignment !== this.glState.unpackAlignment) {
      this.gl.pixelStorei(this.gl.UNPACK_ALIGNMENT, this.unpackAlignment);
      this.glState.unpackAlignment = this.unpackAlignment;
    }
    if (this.minFilter !== this.state.minFilter) {
      this.gl.texParameteri(this.target, this.gl.TEXTURE_MIN_FILTER, this.minFilter);
      this.state.minFilter = this.minFilter;
    }
    if (this.magFilter !== this.state.magFilter) {
      this.gl.texParameteri(this.target, this.gl.TEXTURE_MAG_FILTER, this.magFilter);
      this.state.magFilter = this.magFilter;
    }
    if (this.wrapS !== this.state.wrapS) {
      this.gl.texParameteri(this.target, this.gl.TEXTURE_WRAP_S, this.wrapS);
      this.state.wrapS = this.wrapS;
    }
    if (this.wrapT !== this.state.wrapT) {
      this.gl.texParameteri(this.target, this.gl.TEXTURE_WRAP_T, this.wrapT);
      this.state.wrapT = this.wrapT;
    }
    if (this.wrapR !== this.state.wrapR) {
      this.gl.texParameteri(this.target, this.gl.TEXTURE_WRAP_R, this.wrapR);
      this.state.wrapR = this.wrapR;
    }
    if (this.anisotropy && this.anisotropy !== this.state.anisotropy) {
      this.gl.texParameterf(this.target, this.gl.renderer.getExtension("EXT_texture_filter_anisotropic").TEXTURE_MAX_ANISOTROPY_EXT, this.anisotropy);
      this.state.anisotropy = this.anisotropy;
    }
    if (this.image) {
      if (this.image.width) {
        this.width = this.image.width;
        this.height = this.image.height;
      }
      if (this.target === this.gl.TEXTURE_CUBE_MAP) {
        for (let i5 = 0; i5 < 6; i5++) {
          this.gl.texImage2D(this.gl.TEXTURE_CUBE_MAP_POSITIVE_X + i5, this.level, this.internalFormat, this.format, this.type, this.image[i5]);
        }
      } else if (ArrayBuffer.isView(this.image)) {
        if (this.target === this.gl.TEXTURE_2D) {
          this.gl.texImage2D(this.target, this.level, this.internalFormat, this.width, this.height, 0, this.format, this.type, this.image);
        } else if (this.target === this.gl.TEXTURE_2D_ARRAY || this.target === this.gl.TEXTURE_3D) {
          this.gl.texImage3D(this.target, this.level, this.internalFormat, this.width, this.height, this.length, 0, this.format, this.type, this.image);
        }
      } else if (this.image.isCompressedTexture) {
        for (let level = 0; level < this.image.length; level++) {
          this.gl.compressedTexImage2D(this.target, level, this.internalFormat, this.image[level].width, this.image[level].height, 0, this.image[level].data);
        }
      } else {
        if (this.target === this.gl.TEXTURE_2D) {
          this.gl.texImage2D(this.target, this.level, this.internalFormat, this.format, this.type, this.image);
        } else {
          this.gl.texImage3D(this.target, this.level, this.internalFormat, this.width, this.height, this.length, 0, this.format, this.type, this.image);
        }
      }
      if (this.generateMipmaps) {
        if (!this.gl.renderer.isWebgl2 && (!isPowerOf2(this.image.width) || !isPowerOf2(this.image.height))) {
          this.generateMipmaps = false;
          this.wrapS = this.wrapT = this.gl.CLAMP_TO_EDGE;
          this.minFilter = this.gl.LINEAR;
        } else {
          this.gl.generateMipmap(this.target);
        }
      }
      this.onUpdate && this.onUpdate();
    } else {
      if (this.target === this.gl.TEXTURE_CUBE_MAP) {
        for (let i5 = 0; i5 < 6; i5++) {
          this.gl.texImage2D(this.gl.TEXTURE_CUBE_MAP_POSITIVE_X + i5, 0, this.gl.RGBA, 1, 1, 0, this.gl.RGBA, this.gl.UNSIGNED_BYTE, emptyPixel);
        }
      } else if (this.width) {
        if (this.target === this.gl.TEXTURE_2D) {
          this.gl.texImage2D(this.target, this.level, this.internalFormat, this.width, this.height, 0, this.format, this.type, null);
        } else {
          this.gl.texImage3D(this.target, this.level, this.internalFormat, this.width, this.height, this.length, 0, this.format, this.type, null);
        }
      } else {
        this.gl.texImage2D(this.target, 0, this.gl.RGBA, 1, 1, 0, this.gl.RGBA, this.gl.UNSIGNED_BYTE, emptyPixel);
      }
    }
    this.store.image = this.image;
  }
};

// node_modules/ogl/src/extras/Plane.js
var Plane = class _Plane extends Geometry {
  constructor(gl, { width = 1, height = 1, widthSegments = 1, heightSegments = 1, attributes = {} } = {}) {
    const wSegs = widthSegments;
    const hSegs = heightSegments;
    const num = (wSegs + 1) * (hSegs + 1);
    const numIndices = wSegs * hSegs * 6;
    const position = new Float32Array(num * 3);
    const normal = new Float32Array(num * 3);
    const uv = new Float32Array(num * 2);
    const index = numIndices > 65536 ? new Uint32Array(numIndices) : new Uint16Array(numIndices);
    _Plane.buildPlane(position, normal, uv, index, width, height, 0, wSegs, hSegs);
    Object.assign(attributes, {
      position: { size: 3, data: position },
      normal: { size: 3, data: normal },
      uv: { size: 2, data: uv },
      index: { data: index }
    });
    super(gl, attributes);
  }
  static buildPlane(position, normal, uv, index, width, height, depth, wSegs, hSegs, u3 = 0, v2 = 1, w2 = 2, uDir = 1, vDir = -1, i5 = 0, ii = 0) {
    const io = i5;
    const segW = width / wSegs;
    const segH = height / hSegs;
    for (let iy = 0; iy <= hSegs; iy++) {
      let y3 = iy * segH - height / 2;
      for (let ix = 0; ix <= wSegs; ix++, i5++) {
        let x2 = ix * segW - width / 2;
        position[i5 * 3 + u3] = x2 * uDir;
        position[i5 * 3 + v2] = y3 * vDir;
        position[i5 * 3 + w2] = depth / 2;
        normal[i5 * 3 + u3] = 0;
        normal[i5 * 3 + v2] = 0;
        normal[i5 * 3 + w2] = depth >= 0 ? 1 : -1;
        uv[i5 * 2] = ix / wSegs;
        uv[i5 * 2 + 1] = 1 - iy / hSegs;
        if (iy === hSegs || ix === wSegs) continue;
        let a3 = io + ix + iy * (wSegs + 1);
        let b3 = io + ix + (iy + 1) * (wSegs + 1);
        let c4 = io + ix + (iy + 1) * (wSegs + 1) + 1;
        let d3 = io + ix + iy * (wSegs + 1) + 1;
        index[ii * 6] = a3;
        index[ii * 6 + 1] = b3;
        index[ii * 6 + 2] = d3;
        index[ii * 6 + 3] = b3;
        index[ii * 6 + 4] = c4;
        index[ii * 6 + 5] = d3;
        ii++;
      }
    }
  }
};

// components/ds-book-parade/ds-book-parade.ts
var SIZE_MAP = {
  xs: { bookWidth: 40, bookHeight: 60, gap: 6, rowGap: 6, radius: 0 },
  sm: { bookWidth: 56, bookHeight: 84, gap: 8, rowGap: 8, radius: 0 },
  md: { bookWidth: 76, bookHeight: 114, gap: 10, rowGap: 10, radius: 0 },
  lg: { bookWidth: 100, bookHeight: 150, gap: 12, rowGap: 12, radius: 0 },
  xl: { bookWidth: 130, bookHeight: 195, gap: 14, rowGap: 14, radius: 0 },
  "2xl": { bookWidth: 170, bookHeight: 255, gap: 28, rowGap: 28, radius: 0 }
};
var DEFAULT_PALETTE = [
  "#ff85e1",
  // honk (pink-500)
  "#2b6cd3",
  // parrot-blue (blue-500)
  "#fffe69",
  // cheeky-chick (yellow-200)
  "#98e9b0",
  // menty-b (green-200)
  "#ff3a5b",
  // ruffled-red (red-400)
  "#8eccff",
  // bluebird (blue-200)
  "#e74ac1",
  // fancy-feathers (pink-700)
  "#ff6a21",
  // duck-duck-goose (orange-400)
  "#bfffd2",
  // duck-egg (green-100)
  "#ffc6f1",
  // get-plucked (pink-300)
  "#ffb1b1",
  // hatchling (red-100)
  "#cde8ff"
  // paddle (blue-100)
];
var BASE_SPEED = 40;
var SHADOW_PAD = 28;
var FLIP_INTERVAL = 3;
var FLIP_FORWARD = 0.4;
var FLIP_RETURN = 0.4;
var FLIP_TOTAL = FLIP_FORWARD + FLIP_RETURN;
var VERTEX = (
  /* glsl */
  `
  attribute vec2 uv;
  attribute vec3 position;
  uniform mat4 modelViewMatrix;
  uniform mat4 projectionMatrix;
  uniform float uFlipProgress;
  varying vec2 vUv;
  void main() {
    vUv = uv;

    // uFlipProgress 0..0.5 maps to 0..90deg rotation around Y axis
    float angle = uFlipProgress * 3.14159265;
    float c = cos(angle);
    float s = sin(angle);

    // Rotate the X coordinate; the resulting Z depth drives perspective
    float rx = position.x * c;
    float rz = position.x * s;

    // Fake perspective: vertices further from the camera (higher rz)
    // are scaled down, creating a subtle trapezoid effect.
    // Only applied to X so the book height stays constant.
    float persp = 1.0 / (1.0 + rz * 0.15);

    gl_Position = projectionMatrix * modelViewMatrix * vec4(rx * persp, position.y, 0.0, 1.0);
  }
`
);
var FRAGMENT = (
  /* glsl */
  `
  precision highp float;
  uniform sampler2D uTexture;
  uniform vec3 uColor;
  uniform float uUseTexture;
  uniform float uFlipProgress;
  uniform vec2 uMeshSize;   // full mesh dimensions including shadow padding
  uniform vec2 uBookSize;   // visible book dimensions (smaller than mesh)
  uniform float uRadius;    // corner radius for the rounded rect SDF
  varying vec2 vUv;

  // Returns signed distance to a rounded rectangle centred at origin.
  // Negative inside, zero on edge, positive outside.
  float roundedBoxSDF(vec2 p, vec2 b, float r) {
    vec2 d = abs(p) - b + vec2(r);
    return min(max(d.x, d.y), 0.0) + length(max(d, 0.0)) - r;
  }

  void main() {
    // Convert UV (0..1) to pixel coordinates centred on the mesh
    vec2 p = (vUv - 0.5) * uMeshSize;

    // --- Drop shadow (two layers) ---
    // Layer 1: tight, dark \u2014 close to the book edge
    float sd1 = roundedBoxSDF(p - vec2(3.0, -4.0), uBookSize * 0.5, uRadius);
    float shadow1 = (1.0 - smoothstep(0.0, 8.0, sd1)) * 0.45;
    // Layer 2: soft, wider spread
    float sd2 = roundedBoxSDF(p - vec2(6.0, -8.0), uBookSize * 0.5, uRadius);
    float shadow2 = (1.0 - smoothstep(0.0, 24.0, sd2)) * 0.3;
    // Combine with screen blending so overlapping areas don't go fully black
    float shadow = shadow1 + shadow2 - shadow1 * shadow2;

    // --- Book rectangle ---
    float bd = roundedBoxSDF(p, uBookSize * 0.5, uRadius);
    float bookAlpha = 1.0 - smoothstep(-0.5, 0.5, bd);

    // Sample texture or use flat colour fallback
    vec3 bookColor = uColor;
    vec2 bookUv = clamp((p + uBookSize * 0.5) / uBookSize, 0.0, 1.0);
    if (uUseTexture > 0.5) {
      bookColor = texture2D(uTexture, bookUv).rgb;
    }

    // Book spine effect along the left edge:
    // a dark groove right at the edge, then a subtle highlight
    // where the cover curves away from the spine
    if (bookAlpha > 0.001) {
      float spineX = bookUv.x * uBookSize.x;
      float creaseDist = abs(spineX - 5.0);
      float creaseMask = 1.0 - smoothstep(0.0, 1.5, creaseDist);
      float lum = dot(bookColor, vec3(0.299, 0.587, 0.114));
      float creaseAlpha = creaseMask * mix(0.06, 0.12, 1.0 - lum);
      vec3 creaseColor = lum > 0.5 ? vec3(0.0) : vec3(1.0);
      bookColor = mix(bookColor, creaseColor, creaseAlpha);
    }

    // Composite: book over shadow (standard "over" alpha blending)
    float alpha = bookAlpha + shadow * (1.0 - bookAlpha);
    if (alpha < 0.001) discard;
    vec3 color = bookColor * (bookAlpha / alpha);
    gl_FragColor = vec4(color, alpha);
  }
`
);
function hexToRgb(hex) {
  const r5 = parseInt(hex.slice(1, 3), 16) / 255;
  const g2 = parseInt(hex.slice(3, 5), 16) / 255;
  const b3 = parseInt(hex.slice(5, 7), 16) / 255;
  return [r5, g2, b3];
}
var DsBookParade = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.rows = 3;
    this.size = "md";
    this.speed = 1;
    this.background = "";
    this.colors = [];
    // shared 1×1 plane, scaled per mesh
    // --- Scene layout ---
    this._meshRows = [];
    this._scrollOffsets = [];
    this._stride = 0;
    // horizontal distance between book centres
    this._totalRowWidth = 0;
    // total width of all books in a row (for wrapping)
    this._booksPerRow = 0;
    // --- Animation ---
    this._animFrameId = 0;
    this._lastTime = 0;
    this._visible = true;
    // IntersectionObserver — pause when off-screen
    this._reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    this._width = 0;
    this._height = 0;
    // --- Textures ---
    this._palette = [];
    this._coverImages = [];
    this._textures = [];
    // Tracks which texture index each mesh currently shows (for flip swaps)
    this._meshTexIndices = [];
    // --- Flip animation ---
    this._activeFlip = null;
    this._flipTimer = 0;
    // --- Responsive breakpoints ---
    this._activeSize = "md";
    this._activeRows = 3;
    this._mdQuery = window.matchMedia("(min-width: 800px)");
    this._lgQuery = window.matchMedia("(min-width: 1024px)");
    this._onBreakpointChange = () => {
      if (this._computeActiveConfig()) {
        this._updateNaturalHeight();
        if (this._gl) this._buildScene();
      }
    };
  }
  // ---------------------------------------------------------------------------
  // Lit lifecycle
  // ---------------------------------------------------------------------------
  render() {
    return b2`<slot @slotchange=${this._onSlotChange}></slot>`;
  }
  firstUpdated() {
    this._initPalette();
    this._computeActiveConfig();
    this._updateNaturalHeight();
    this._initWebGL();
    this._defaultTexture = new Texture(this._gl, { generateMipmaps: false });
    if (this._coverImages.length) this._createTextures();
    this._setupObservers();
    this._mdQuery.addEventListener("change", this._onBreakpointChange);
    this._lgQuery.addEventListener("change", this._onBreakpointChange);
  }
  willUpdate(changed) {
    if (changed.has("background")) {
      this.style.setProperty("--_bg", this.background || "transparent");
    }
  }
  updated(changed) {
    if (changed.has("colors") && this._gl) {
      this._initPalette();
    }
    const responsiveChanged = changed.has("rows") || changed.has("rowsMd") || changed.has("rowsLg") || changed.has("size") || changed.has("sizeMd") || changed.has("sizeLg");
    if (responsiveChanged) {
      const activeChanged = this._computeActiveConfig();
      if (activeChanged) {
        this._updateNaturalHeight();
        if (this._gl) this._buildScene();
      }
    }
    if (changed.has("colors") && this._gl) {
      this._buildScene();
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._animFrameId) {
      cancelAnimationFrame(this._animFrameId);
      this._animFrameId = 0;
    }
    this._ro?.disconnect();
    this._io?.disconnect();
    this._mdQuery.removeEventListener("change", this._onBreakpointChange);
    this._lgQuery.removeEventListener("change", this._onBreakpointChange);
  }
  connectedCallback() {
    super.connectedCallback();
    if (this._gl) {
      this._setupObservers();
      this._mdQuery.addEventListener("change", this._onBreakpointChange);
      this._lgQuery.addEventListener("change", this._onBreakpointChange);
      this._computeActiveConfig();
    }
  }
  // ---------------------------------------------------------------------------
  // Slot & texture management
  // ---------------------------------------------------------------------------
  _initPalette() {
    const src = this.colors.length ? this.colors : DEFAULT_PALETTE;
    this._palette = src.map(hexToRgb);
  }
  // When slotted <img> children change, capture them and create GPU textures.
  _onSlotChange(e5) {
    const slot = e5.target;
    this._coverImages = slot.assignedElements().filter((el) => el instanceof HTMLImageElement);
    if (this._gl) {
      this.removeAttribute("ready");
      this._createTextures();
      this._buildScene();
    }
  }
  // Create an OGL Texture for each slotted image. The [ready] attribute
  // is set once every image has loaded (or errored), which triggers the
  // CSS opacity transition to reveal the canvas.
  _createTextures() {
    let loaded = 0;
    const total = this._coverImages.length;
    const checkReady = () => {
      loaded++;
      if (loaded === total) this.setAttribute("ready", "");
    };
    this._textures = this._coverImages.map((img) => {
      const texture = new Texture(this._gl, { generateMipmaps: false });
      if (img.complete) {
        if (img.naturalWidth > 0) texture.image = img;
        checkReady();
      } else {
        img.addEventListener(
          "load",
          () => {
            texture.image = img;
            checkReady();
          },
          { once: true }
        );
        img.addEventListener("error", checkReady, { once: true });
      }
      return texture;
    });
  }
  // ---------------------------------------------------------------------------
  // Responsive breakpoint handling
  // ---------------------------------------------------------------------------
  // Determines the active book size and row count based on the current
  // viewport. Uses matchMedia (not ResizeObserver) so it stays in sync
  // with the CSS breakpoints at 800px and 1024px.
  _computeActiveConfig() {
    const lg = this._lgQuery.matches;
    const md = this._mdQuery.matches;
    const newSize = lg && this.sizeLg || md && this.sizeMd || this.size;
    const newRows = (lg && this.rowsLg != null ? this.rowsLg : null) ?? (md && this.rowsMd != null ? this.rowsMd : null) ?? this.rows;
    const changed = newSize !== this._activeSize || newRows !== this._activeRows;
    this._activeSize = newSize;
    this._activeRows = newRows;
    return changed;
  }
  // Sets CSS custom properties used by the host's height and the
  // (currently hidden) slot layout fallback.
  _updateNaturalHeight() {
    const cfg = SIZE_MAP[this._activeSize] || SIZE_MAP.md;
    const total = this._activeRows * cfg.bookHeight + (this._activeRows - 1) * cfg.rowGap + SHADOW_PAD;
    this.style.setProperty("--_natural-height", `${total}px`);
    this.style.setProperty("--_book-width", `${cfg.bookWidth}px`);
    this.style.setProperty("--_book-height", `${cfg.bookHeight}px`);
    this.style.setProperty("--_gap", `${cfg.gap}px`);
    this.style.setProperty("--_radius", `${cfg.radius}px`);
    this.style.setProperty("--_shadow-pad", `${SHADOW_PAD}px`);
  }
  // ---------------------------------------------------------------------------
  // WebGL setup
  // ---------------------------------------------------------------------------
  _initWebGL() {
    const renderer = new Renderer({
      alpha: true,
      // transparent canvas so CSS background shows through
      premultipliedAlpha: false,
      dpr: Math.min(window.devicePixelRatio, 2),
      antialias: true
    });
    this._renderer = renderer;
    this._gl = renderer.gl;
    this.shadowRoot.appendChild(this._gl.canvas);
    this._camera = new Camera(this._gl);
    this._scene = new Transform();
    this._geometry = new Plane(this._gl, { width: 1, height: 1 });
  }
  _setupObservers() {
    this._ro?.disconnect();
    this._io?.disconnect();
    this._ro = new ResizeObserver((entries) => {
      const { width, height } = entries[0].contentRect;
      if (width > 0 && height > 0 && (width !== this._width || height !== this._height)) {
        this._width = width;
        this._height = height;
        this._onResize();
      }
    });
    this._ro.observe(this);
    this._io = new IntersectionObserver(
      ([entry]) => {
        this._visible = entry.isIntersecting;
        if (this._visible && !this._animFrameId && this._width > 0) {
          this._lastTime = performance.now();
          this._startLoop();
        }
      },
      { threshold: 0 }
    );
    this._io.observe(this);
  }
  _onResize() {
    this._renderer.setSize(this._width, this._height);
    this._camera.orthographic({
      left: -this._width / 2,
      right: this._width / 2,
      top: this._height / 2,
      bottom: -this._height / 2,
      near: 0.1,
      far: 100
    });
    this._camera.position.z = 10;
    this._buildScene();
    this._updatePositions(0);
    this._renderer.render({ scene: this._scene, camera: this._camera });
    if (!this._animFrameId) this._startLoop();
  }
  // ---------------------------------------------------------------------------
  // Scene construction
  // ---------------------------------------------------------------------------
  // Tears down and rebuilds all book meshes. Called on resize, breakpoint
  // change, and when slotted images change. Each book is a scaled Plane
  // mesh with its own Program (shader + uniforms). The mesh is larger
  // than the visible book to provide room for the drop shadow.
  _buildScene() {
    for (const row of this._meshRows) {
      for (const mesh of row) {
        mesh.setParent(null);
      }
    }
    this._meshRows = [];
    this._meshTexIndices = [];
    this._scrollOffsets = [];
    this._activeFlip = null;
    if (this._width === 0 || this._height === 0) return;
    const cfg = SIZE_MAP[this._activeSize] || SIZE_MAP.md;
    const { bookWidth, bookHeight, gap, rowGap, radius } = cfg;
    this._stride = bookWidth + gap;
    this._booksPerRow = Math.ceil(this._width / this._stride) + 3;
    this._totalRowWidth = this._booksPerRow * this._stride;
    const totalContentHeight = this._activeRows * bookHeight + (this._activeRows - 1) * rowGap;
    const startY = totalContentHeight / 2 - bookHeight / 2 + SHADOW_PAD / 2;
    for (let r5 = 0; r5 < this._activeRows; r5++) {
      const rowMeshes = [];
      const rowTexIndices = [];
      const y3 = startY - r5 * (bookHeight + rowGap);
      for (let b3 = 0; b3 < this._booksPerRow; b3++) {
        const idx = (b3 + r5 * 4) % Math.max(this._palette.length, 1);
        const [cr, cg, cb] = this._palette[idx] || [0.8, 0.8, 0.8];
        const hasTextures = this._textures.length > 0;
        const texIdx = hasTextures ? (b3 + r5 * 4) % this._textures.length : 0;
        const meshW = bookWidth + SHADOW_PAD * 2;
        const meshH = bookHeight + SHADOW_PAD * 2;
        const program = new Program(this._gl, {
          vertex: VERTEX,
          fragment: FRAGMENT,
          uniforms: {
            uColor: { value: [cr, cg, cb] },
            uTexture: {
              value: hasTextures ? this._textures[texIdx] : this._defaultTexture
            },
            uUseTexture: { value: hasTextures ? 1 : 0 },
            uMeshSize: { value: [meshW, meshH] },
            uBookSize: { value: [bookWidth, bookHeight] },
            uRadius: { value: radius },
            uFlipProgress: { value: 0 }
          },
          transparent: true,
          depthTest: false,
          depthWrite: false,
          cullFace: false
          // both faces visible during flip rotation
        });
        const mesh = new Mesh(this._gl, {
          geometry: this._geometry,
          program
        });
        mesh.scale.set(meshW, meshH, 1);
        mesh.position.y = y3;
        mesh.setParent(this._scene);
        rowMeshes.push(mesh);
        rowTexIndices.push(texIdx);
      }
      this._meshRows.push(rowMeshes);
      this._meshTexIndices.push(rowTexIndices);
      this._scrollOffsets.push(0);
    }
    if (this._textures.length === 0) {
      this.setAttribute("ready", "");
    }
  }
  // ---------------------------------------------------------------------------
  // Animation loop
  // ---------------------------------------------------------------------------
  _startLoop() {
    if (this._reduceMotion.matches) {
      this._updatePositions(0);
      this._renderer.render({ scene: this._scene, camera: this._camera });
      return;
    }
    this._lastTime = performance.now();
    const tick = (now) => {
      if (!this._visible) {
        this._animFrameId = 0;
        return;
      }
      this._animFrameId = requestAnimationFrame(tick);
      const dt = Math.min((now - this._lastTime) / 1e3, 0.1);
      this._lastTime = now;
      this._updatePositions(dt);
      this._updateFlips(dt);
      this._renderer.render({
        scene: this._scene,
        camera: this._camera
      });
    };
    this._animFrameId = requestAnimationFrame(tick);
  }
  // Infinite scroll: each row scrolls in the opposite direction.
  // Book positions wrap around using modular arithmetic so the
  // parade loops seamlessly.
  _updatePositions(dt) {
    const speed = BASE_SPEED * this.speed;
    const halfTotal = this._totalRowWidth / 2;
    for (let r5 = 0; r5 < this._meshRows.length; r5++) {
      const direction = r5 % 2 === 0 ? 1 : -1;
      this._scrollOffsets[r5] += direction * speed * dt;
      const row = this._meshRows[r5];
      for (let b3 = 0; b3 < row.length; b3++) {
        const baseX = b3 * this._stride;
        const scrolled = baseX + this._scrollOffsets[r5];
        const wrapped = (scrolled % this._totalRowWidth + this._totalRowWidth) % this._totalRowWidth;
        row[b3].position.x = wrapped - halfTotal;
      }
    }
  }
  // Card flip: every FLIP_INTERVAL seconds, pick a random book and
  // animate it rotating to 90deg (edge-on). At the midpoint the
  // texture is swapped to a different cover, then the book rotates
  // back to 0deg showing the new cover. Requires at least 2 textures.
  _updateFlips(dt) {
    if (this._meshRows.length === 0 || this._textures.length < 2) return;
    this._flipTimer += dt;
    if (!this._activeFlip && this._flipTimer >= FLIP_INTERVAL) {
      const row = Math.floor(Math.random() * this._meshRows.length);
      const col = Math.floor(Math.random() * this._meshRows[row].length);
      this._activeFlip = { row, col, time: 0, swapped: false };
      this._flipTimer = 0;
    }
    if (this._activeFlip) {
      this._activeFlip.time += dt;
      const { row, col } = this._activeFlip;
      const mesh = this._meshRows[row]?.[col];
      if (!mesh) {
        this._activeFlip = null;
        return;
      }
      const t4 = this._activeFlip.time;
      let raw;
      if (t4 < FLIP_FORWARD) {
        const phase = t4 / FLIP_FORWARD;
        raw = (0.5 - 0.5 * Math.cos(phase * Math.PI)) * 0.5;
      } else {
        const phase = (t4 - FLIP_FORWARD) / FLIP_RETURN;
        raw = 0.5 - (0.5 - 0.5 * Math.cos(phase * Math.PI)) * 0.5;
      }
      mesh.program.uniforms.uFlipProgress.value = Math.max(0, Math.min(0.5, raw));
      if (t4 >= FLIP_FORWARD && !this._activeFlip.swapped) {
        this._activeFlip.swapped = true;
        const currentIdx = this._meshTexIndices[row][col];
        let newIdx;
        do {
          newIdx = Math.floor(Math.random() * this._textures.length);
        } while (newIdx === currentIdx);
        mesh.program.uniforms.uTexture.value = this._textures[newIdx];
        this._meshTexIndices[row][col] = newIdx;
      }
      if (t4 >= FLIP_TOTAL) {
        mesh.program.uniforms.uFlipProgress.value = 0;
        this._activeFlip = null;
      }
    }
  }
};
DsBookParade.styles = [...BaseComponent.styles, r(ds_book_parade_default)];
__decorateClass([
  n4({ type: Number })
], DsBookParade.prototype, "rows", 2);
__decorateClass([
  n4({ type: Number, attribute: "rows-md" })
], DsBookParade.prototype, "rowsMd", 2);
__decorateClass([
  n4({ type: Number, attribute: "rows-lg" })
], DsBookParade.prototype, "rowsLg", 2);
__decorateClass([
  n4({ reflect: true })
], DsBookParade.prototype, "size", 2);
__decorateClass([
  n4({ attribute: "size-md" })
], DsBookParade.prototype, "sizeMd", 2);
__decorateClass([
  n4({ attribute: "size-lg" })
], DsBookParade.prototype, "sizeLg", 2);
__decorateClass([
  n4({ type: Number })
], DsBookParade.prototype, "speed", 2);
__decorateClass([
  n4()
], DsBookParade.prototype, "background", 2);
__decorateClass([
  n4({ type: Array })
], DsBookParade.prototype, "colors", 2);
DsBookParade = __decorateClass([
  t3("ds-book-parade")
], DsBookParade);
export {
  DsBookParade
};
/*! Bundled license information:

@lit/reactive-element/css-tag.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/reactive-element.js:
lit-html/lit-html.js:
lit-element/lit-element.js:
@lit/reactive-element/decorators/custom-element.js:
@lit/reactive-element/decorators/property.js:
@lit/reactive-element/decorators/state.js:
@lit/reactive-element/decorators/event-options.js:
@lit/reactive-element/decorators/base.js:
@lit/reactive-element/decorators/query.js:
@lit/reactive-element/decorators/query-all.js:
@lit/reactive-element/decorators/query-async.js:
@lit/reactive-element/decorators/query-assigned-nodes.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-html/is-server.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-assigned-elements.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
